var canvas, stage, canvas_container;
var drawing_container, none_tile_areas_container, none_tile_poligons;
var selected_type, selected_tile; 
var current_stage, previous_stage;
var square;
var scale;
var width, height;
var tile;
var tile_images;
var color_images;
var room_size;
var colors;
var report;
var drag_measures;
var matriz;
var matriz_data;
var matriz_changed = false;
var scale_changed = false;
var pattern;
var resize_cont;
var unit_system;
var edges_and_corners;
var edges_type;
var edges_colors;
var stage_click = false;
var media_limit = 1024;
var unset_color = "*Erase"
var layer_matrix, layer_borders_ands_edges;
var design_name = "";
var custom_tile_container = [];
var custom_tile_data = [];
var container_visibility = [];
var custom_design_imported = false;
var doorsOnCanvas = [];

var real_points_reset;
var fd_cd_id = 0;
var fd_cd_name = 0;

jQuery(document).on("click", ".sid-room-shape-label", function(evt) {
  evt.preventDefault();
  if (current_stage == 1) {
    showLoading();

    // Create a Promise to handle the sequence
    new Promise((resolve) => {
      // Resolve immediately to let the browser render the loading overlay
      setTimeout(resolve, 0);
    }).then(() => {
      // Now run the rest of the code
      jQuery("#sid-loaded-custom-design").attr("loaded", "0");
      custom_design_imported = false;
      var type = jQuery(this).parent().find('input').val();
      if (type == "bl_l_shape" || type == "t_t_shape") {
        jQuery("#rotate_this").show();
      } else {
        jQuery("#rotate_this").hide();
      }
      room_type_fields(type);
      selected_type = data.types[type];
      init_dimentions();
      init_process_vars();
      load_step(2);
      zoom_level_fix();
      refresh_door();
      real_points_reset = JSON.parse(JSON.stringify(selected_type.real_points));
      jQuery("#unit_system_metric").click();
      hideLoading();
    });
  }
});


function initDoorUI() {
    $(".door_2").hide();
   $("input[name='unit_system']").on('input change', function() {
  
    refresh_door();
    clearDoors();
    switch(unit_system){
      case "metric":
        // jQuery(this).val(imperial_numbert_to_format(jQuery(this).val()));
      break;
      case "centimeter":
        jQuery("#first_door_width").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_width").val()));
        jQuery("#first_door_left").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_left").val()));
        jQuery("#first_door_top").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_top").val()));

        jQuery("#second_door_width").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_width").val()));
        jQuery("#second_door_left").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_left").val()));
        jQuery("#second_door_top").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_top").val()));
      break;
      case "inches":
        jQuery("#first_door_width").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_width").val()));
        jQuery("#first_door_left").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_left").val()));
        jQuery("#first_door_top").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_top").val()));

        jQuery("#second_door_width").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_width").val()));
        jQuery("#second_door_left").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_left").val()));
        jQuery("#second_door_top").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_top").val()));
      break;
      case"imperial":
      default:
        jQuery("#first_door_width").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_width").val()));
        jQuery("#first_door_left").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_left").val()));
        jQuery("#first_door_top").val(imperial_numbert_to_format_centimeter(jQuery("#first_door_top").val()));

        jQuery("#second_door_width").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_width").val()));
        jQuery("#second_door_left").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_left").val()));
        jQuery("#second_door_top").val(imperial_numbert_to_format_centimeter(jQuery("#second_door_top").val()));
      break;
    }
    });
    

}

function showLoading() {
  jQuery('.loading-overlay').show();
}
jQuery(document).on('change', "input[id^='first_door_'], input[id^='second_door_']", function (e) {
  var isSecondDoor = $(this).attr('id').startsWith('second_door_');
  updateDoorProperties(isSecondDoor);
});

jQuery(document).on('click', ".add_door_class", function (e) {
  var doorType = $(this).attr("door_type");
  handleDoorSelection(doorType);
});

jQuery(document).on('click', '.tileimage', function (e) {
  jQuery(".tileimage").removeClass("selected_tile");
  jQuery(this).addClass("selected_tile");
  update_color_fill_list();
  
  layers_reload(false);
  normal_load_action();
});
function update_color_fill_list() {
  var template_val = $('.tileimage.selected_tile').attr("template");
  if(template_val == 1) {
    $("#color-primary").show();
    $("#color-second").show();
    $("#color-third").hide();
    $("#color-fourth").hide();
  }
  if(template_val == 2) {
    $("#color-primary").show();
    $("#color-second").show();
    $("#color-third").show();
    $("#color-fourth").hide();
  }
  if(template_val == 3) {
    $("#color-primary").show();
    $("#color-second").show();
    $("#color-third").hide();
    $("#color-fourth").hide();
  }
  if(template_val == 4) {
    $("#color-primary").show();
    $("#color-second").show();
    $("#color-third").hide();
    $("#color-fourth").hide();
  }
  if(template_val == 5) {
    $("#color-primary").show();
    $("#color-second").show();
    $("#color-third").show();
    $("#color-fourth").show();
  }
  update_selected_same_color_value(template_val);
}

function update_selected_same_color_value(template_val){
  if(template_val == 1) {
    jQuery("#color-primary input#sid-ptc-6").prop('checked', true);
    jQuery("#color-second input#sid-sec-ptc-7").prop('checked', true);
  } else if(template_val == 2) {
    jQuery("#color-primary input#sid-ptc-8").prop('checked', true);
    jQuery("#color-second input#sid-sec-ptc-6").prop('checked', true);
    jQuery("#color-third input#sid-thr-ptc-5").prop('checked', true);
  } else if(template_val == 3) {
    jQuery("#color-primary input#sid-ptc-6").prop('checked', true);
    jQuery("#color-second input#sid-sec-ptc-3").prop('checked', true);
  } else if(template_val == 4) {
    jQuery("#color-primary input#sid-ptc-6").prop('checked', true);
    jQuery("#color-second input#sid-sec-ptc-9").prop('checked', true);
  } else if(template_val == 5) {
    jQuery("#color-primary input#sid-ptc-6").prop('checked', true);
    jQuery("#color-second input#sid-sec-ptc-4").prop('checked', true);
    jQuery("#color-third input#sid-thr-ptc-3").prop('checked', true);
    jQuery("#color-fourth input#sid-four-ptc-8").prop('checked', true);
  }
}
function handleDoorSelection(doorType) {
    clearDoors();


  switch(unit_system){
    case "metric":
      var properties = {
        '1': [{width: 1, height: 5, left: 0.500, top: 0.500, rotate: 0}],
        '2': [
          {width: 1, height: 5, left: 0.500, top: 0.500, rotate: 0},
          {width: 1, height: 5, left: 0.500, top: 0.750, rotate: 0}
        ],
        '3': [{width: 2, height: 5, left: 0.500, top: 0.500, rotate: 0}]
      };
    break;
    case "centimeter":
      var properties = {
        '1': [{width: 1, height: 5, left: 0.500, top: 0.500, rotate: 0}],
        '2': [
          {width: 1, height: 5, left: 0.500, top: 0.500, rotate: 0},
          {width: 1, height: 5, left: 0.500, top: 0.750, rotate: 0}
        ],
        '3': [{width: 2, height: 5, left: 0.500, top: 0.500, rotate: 0}]
      };
    break;
    case "inches":
      var properties = {
        '1': [{width: 1, height: 5, left: 0.500, top: 0.500, rotate: 0}],
        '2': [
          {width: 1, height: 5, left: 0.500, top: 0.500, rotate: 0},
          {width: 1, height: 5, left: 0.500, top: 0.750, rotate: 0}
        ],
        '3': [{width: 2, height: 5, left: 0.500, top: 0.500, rotate: 0}]
      };
    break;
    case"imperial":
    default:
      var properties = {
        '1': [{width: 3, height: 5, left: 2, top: 2, rotate: 0}],
        '2': [
          {width: 3, height: 5, left: 2, top: 2, rotate: 0},
          {width: 3, height: 5, left: 2, top: 3, rotate: 0}
        ],
        '3': [{width: 5, height: 5, left: 2, top: 2, rotate: 0}]
      };
    break;
  }

    properties[doorType].forEach((door, index) => {
        addOrUpdateDoor(door, index);
    });


    $(".door_2").toggle(doorType === '2');

    $(".door-rotation").val(0);
    $(".rotation-input").val('0°');
}

function clearDoors() {
    doorsOnCanvas.forEach(door => {
        stage.removeChild(door);
    });
    doorsOnCanvas = [];
    stage.update();
}


function addOrUpdateDoor(properties, index) {
    var door = doorsOnCanvas[index];
    var lineThickness = 5; // Thickness of the pink line
    var lineColor = "pink"; // Color of the line
    if (!door) {
        door = new createjs.Container();
        doorsOnCanvas[index] = door;
        stage.addChild(door);
    }

    door.removeAllChildren(); // Clear any previous shapes in the container

    var leftLine = new createjs.Shape();
    leftLine.graphics.beginFill(lineColor).drawRect(0, -5, lineThickness, properties.height + 10).endFill();

    var rightLine = new createjs.Shape();


  var current_scale = calc_scale();

  let nTop;
  let nLeft;
  let nWidth;
  switch(unit_system){
    case "metric":
    break;
    case "centimeter":
      properties.top = imperial_numbert_to_format_centimeter(properties.top);
      properties.left = imperial_numbert_to_format_centimeter(properties.left);
      properties.width = imperial_numbert_to_format_centimeter(properties.width);
    break;
    case "inches":
      properties.top = imperial_numbert_to_format_centimeter(properties.top);
      properties.left = imperial_numbert_to_format_centimeter(properties.left);
      properties.width = imperial_numbert_to_format_centimeter(properties.width);
    break;
    case"imperial":
    default:

      properties.left = format_number_measure(properties.left);
      properties.top = format_number_measure(properties.top);
      properties.width = format_number_measure(properties.width);

      var measure_lenght = parseFloat(properties.width);
      var measure_lenght_units = calc_feet(measure_lenght);
      var measure_lenght_decimals = calc_inches(measure_lenght);
      if(measure_lenght_decimals == 12) {
        measure_lenght_units += 1;
        measure_lenght_decimals = 0;
      }
      properties.width = measure_lenght_units + "'" + measure_lenght_decimals + "\"";

      var measure_lenght_left = parseFloat(properties.left);
      var measure_lenght_units_left = calc_feet(measure_lenght_left);
      var measure_lenght_decimals_left = calc_inches(measure_lenght_left);
      if(measure_lenght_decimals_left == 12) {
        measure_lenght_units_left += 1;
        measure_lenght_decimals_left = 0;
      }

      properties.left = measure_lenght_units_left + "'" + measure_lenght_decimals_left + "\"";
      var measure_lenght_top = parseFloat(properties.top);
      var measure_lenght_units_top = calc_feet(measure_lenght_top);
      var measure_lenght_decimals_top = calc_inches(measure_lenght_top);
      if(measure_lenght_decimals_top == 12) {
        measure_lenght_units_top += 1;
        measure_lenght_decimals_top = 0;
      }
      properties.top = measure_lenght_units_top + "'" + measure_lenght_decimals_top + "\"";
    break;
  }


  switch(unit_system){
    case("metric"):{
      nTop = parseFloat(calc_meters("to", properties.top)) * current_scale;
      nLeft = parseFloat(calc_meters("to", properties.left)) * current_scale;
      nWidth = parseFloat(calc_meters("to", properties.width)) * current_scale;
      break;
    }
    case("centimeter"):{
      nTop = (parseFloat(parseFloat(calc_meters("to", properties.top)) * current_scale) * 100).toFixed(3) + 'cm';
      nLeft = (parseFloat(parseFloat(calc_meters("to", properties.left)) * current_scale) * 100).toFixed(3) + 'cm';
      nWidth = (parseFloat(parseFloat(calc_meters("to", properties.width)) * current_scale) * 100).toFixed(3) + 'cm';
      break;
    }
    case("inches"):{
      nTop = (parseFloat(parseFloat(calc_meters("to", properties.top)) * current_scale) * 39.3701).toFixed(3) + 'inches';
      nLeft = (parseFloat(parseFloat(calc_meters("to", properties.left)) * current_scale) * 39.3701).toFixed(3) + 'inches';
      nWidth = (parseFloat(parseFloat(calc_meters("to", properties.width)) * current_scale) * 39.3701).toFixed(3) + 'inches';
      break;
    }
    case("imperial"):
    default:{
      nTop = parseFloat(get_unit_imperial(imperial_format_to_decimal(properties.top))) * current_scale;
      nLeft = parseFloat(get_unit_imperial(imperial_format_to_decimal(properties.left))) * current_scale;
      nWidth = parseFloat(get_unit_imperial(imperial_format_to_decimal(properties.width))) * current_scale;
      break;
    }
  }   


  rightLine.graphics.beginFill(lineColor).drawRect(nWidth + lineThickness, -5, lineThickness, properties.height + 10).endFill();

    var doorShape = new createjs.Shape();
    doorShape.graphics.beginFill("purple").drawRect(lineThickness, 0, nWidth, properties.height).endFill();

    door.addChild(leftLine, doorShape, rightLine);

    door.regX = 0;  // Align horizontally
    door.regY = 0;  // Align vertically

    door.x = nLeft - lineThickness;  // Adjust X to include the left line
    door.y = nTop + 5;  // Adjust Y to move the door up by 5 pixels

    door.rotation = properties.rotate;

    door.on("pressmove", function(evt) {
        var nTop = 0;
        var nLeft = 0;
        var nWidth = 0;
     
    switch(unit_system){
      case("metric"):{
        var measure_lenght = parseFloat(calc_meters("from", evt.stageX));
        nTop = (measure_lenght / current_scale).toFixed(3);
        var measure_lenght_nLeft = parseFloat(calc_meters("from", evt.stageY));
        nLeft = (measure_lenght_nLeft / current_scale).toFixed(3);
        nWidth = properties.width;
        nWidth = parseFloat(properties.width).toFixed(3);
        break;
      }
      case("centimeter"):{
        var measure_lenght = parseFloat(calc_meters("from", evt.stageX));
        nTop = ((measure_lenght / current_scale) * 100).toFixed(3);
        var measure_lenght_nLeft = parseFloat(calc_meters("from", evt.stageY));
        nLeft = ((measure_lenght_nLeft / current_scale) * 100).toFixed(3);
        nWidth = properties.width;

        break;
      }
      case("inches"):{
        var measure_lenght = parseFloat(calc_meters("from", evt.stageX));
        nTop = ((measure_lenght / current_scale) * 39.3701).toFixed(3);
        var measure_lenght_nLeft = parseFloat(calc_meters("from", evt.stageY));
        nLeft = ((measure_lenght_nLeft / current_scale) * 39.3701).toFixed(3);
        nWidth = properties.width;

        break;
      }
      case("imperial"):
      default:{
        var measure_lenght = parseFloat(evt.stageX);
        measure_lenght = measure_lenght  / current_scale;
        var measure_lenght_units = calc_feet(measure_lenght);
        var measure_lenght_decimals = calc_inches(measure_lenght);
        if(measure_lenght_decimals == 12) {
          measure_lenght_units += 1;
          measure_lenght_decimals = 0;
        }
        nTop = measure_lenght_units + "'" + measure_lenght_decimals + "\"";
        
        var measure_lenght_Y = parseFloat(evt.stageY);
        measure_lenght_Y = measure_lenght_Y  / current_scale;
        var measure_lenght_units_Y = calc_feet(measure_lenght_Y);
        var measure_lenght_decimals_Y = calc_inches(measure_lenght_Y);
        if(measure_lenght_decimals_Y == 12) {
          measure_lenght_units_Y += 1;
          measure_lenght_decimals_Y = 0;
        }
        nLeft = measure_lenght_units_Y + "'" + measure_lenght_decimals_Y + "\"";

        nWidth = properties.width;
        break;
      }
    }
  
        door.x = evt.stageX;
        door.y = evt.stageY;

        stage.update();
    updateInputFields(nTop, nLeft, nWidth, door.height, door.rotation, index);
  });
    updateDoorInputs(properties, index);
    stage.update();
}






function updateInputFields(x, y, width, height, rotation, index) {
    var prefix = index === 0 ? 'first_' : 'second_'; 
  if(width == 'NaN') {
      // $("#" + prefix + "door_width").val(width);
  } else {
      $("#" + prefix + "door_width").val(width);
  }
    $("#" + prefix + "door_left").val(x);
    $("#" + prefix + "door_top").val(y);
    $("#" + prefix + "door_rotation").val(rotation);
}
function updateDoorRotationAndPosition(door, rotation, index) {
  var current_scale = calc_scale();

  door.rotation = rotation;

    stage.update();

  var nTop = 0;
  var nLeft = 0;
  var nWidth = 0;
  switch(unit_system){
    case("metric"):{
      var measure_lenght = parseFloat(calc_meters("from", door.x - door.regX));
      nTop = (measure_lenght / current_scale).toFixed(3);
      var measure_lenght_nLeft = parseFloat(calc_meters("from", door.y - door.regY));
      nLeft = (measure_lenght_nLeft / current_scale).toFixed(3);
      // var measure_lenght_nWidth = parseFloat(calc_meters("from", door.width));
      // nWidth = (measure_lenght_nWidth / current_scale).toFixed(3);
      break;
    }
    case("centimeter"):{
      var measure_lenght = parseFloat(calc_meters("from", door.x - door.regX));
      nTop = ((measure_lenght / current_scale) * 100).toFixed(3);
      var measure_lenght_nLeft = parseFloat(calc_meters("from", door.y - door.regY));
      nLeft = ((measure_lenght_nLeft / current_scale) * 100).toFixed(3);
      // var measure_lenght_nWidth = parseFloat(calc_meters("from", door.width));
      // nWidth = ((measure_lenght_nWidth / current_scale) * 100).toFixed(3);

      break;
    }
    case("inches"):{
      var measure_lenght = parseFloat(calc_meters("from", door.x - door.regX));
      nTop = ((measure_lenght / current_scale) * 39.3701).toFixed(3);
      var measure_lenght_nLeft = parseFloat(calc_meters("from", door.y - door.regY));
      nLeft = ((measure_lenght_nLeft / current_scale) * 39.3701).toFixed(3);
      // var measure_lenght_nWidth = parseFloat(calc_meters("from", door.width));
      // nWidth = ((measure_lenght_nWidth / current_scale) * 39.3701).toFixed(3);

      break;
    }
    case("imperial"):
    default:{
      var measure_lenght = parseFloat(door.x - door.regX);
      measure_lenght = measure_lenght  / current_scale;
      var measure_lenght_units = calc_feet(measure_lenght);
      var measure_lenght_decimals = calc_inches(measure_lenght);
      if(measure_lenght_decimals == 12) {
        measure_lenght_units += 1;
        measure_lenght_decimals = 0;
      }
      nTop = measure_lenght_units + "'" + measure_lenght_decimals + "\"";
      
      var measure_lenght_Y = parseFloat(door.y - door.regY);
      measure_lenght_Y = measure_lenght  / current_scale;
      var measure_lenght_units_Y = calc_feet(measure_lenght_Y);
      var measure_lenght_decimals_Y = calc_inches(measure_lenght_Y);
      if(measure_lenght_decimals_Y == 12) {
        measure_lenght_units_Y += 1;
        measure_lenght_decimals_Y = 0;
      }
      nLeft = measure_lenght_units_Y + "'" + measure_lenght_decimals_Y + "\"";

      
      // var measure_lenght_W = parseFloat(door.width);
      // measure_lenght_W = measure_lenght  / current_scale;
      // var measure_lenght_units_W = calc_feet(measure_lenght_W);
      // var measure_lenght_decimals_W = calc_inches(measure_lenght_W);
      // if(measure_lenght_decimals_W == 12) {
      //  measure_lenght_units_W += 1;
      //  measure_lenght_decimals_W = 0;
      // }
      // nWidth = measure_lenght_units_W + "'" + measure_lenght_decimals_W + "\"";
      break;
    }
  }
    updateInputFields(nTop, nLeft, 'NaN', door.height, door.rotation, index);
}

function updateDoorInputs(properties, index) {
  var prefix = index === 0 ? 'first_' : 'second_';
  switch(unit_system){
    case "metric":
      $("#" + prefix + "door_width").val(parseFloat(properties.width).toFixed(3));
      $("#" + prefix + "door_left").val(parseFloat(properties.left).toFixed(3));
      $("#" + prefix + "door_top").val(parseFloat(properties.top).toFixed(3));
      $("#" + prefix + "door_rotation").val(properties.rotate);
    break;
    case "centimeter":
      $("#" + prefix + "door_width").val(parseFloat(properties.width).toFixed(3));
      $("#" + prefix + "door_left").val(parseFloat(properties.left).toFixed(3));
      $("#" + prefix + "door_top").val(parseFloat(properties.top).toFixed(3));
      $("#" + prefix + "door_rotation").val(properties.rotate);
    break;
    case "inches":
      $("#" + prefix + "door_width").val(parseFloat(properties.width).toFixed(3));
      $("#" + prefix + "door_left").val(parseFloat(properties.left).toFixed(3));
      $("#" + prefix + "door_top").val(parseFloat(properties.top).toFixed(3));
      $("#" + prefix + "door_rotation").val(properties.rotate);
    break;
    case"imperial":
    default:
      $("#" + prefix + "door_width").val(properties.width);
      $("#" + prefix + "door_left").val(properties.left);
      $("#" + prefix + "door_top").val(properties.top);
      $("#" + prefix + "door_rotation").val(properties.rotate);
    break;
  }
}


function updateDoorProperties(isSecondDoor) {
  
  if (isSecondDoor) {
    var width = $("#second_door_width").val(); // Default values if none set
    var height = parseInt(5);
    var left = $("#second_door_left").val();
    var top = $("#second_door_top").val();
    var rotation = jQuery(".door_1 .rotation-input").val();
    var rotation = rotation.replace(/°/g, "");
  } else {
    var width = $("#first_door_width").val(); // Default values if none set
    var height = parseInt(5);
    var left = $("#first_door_left").val();
    var top = $("#first_door_top").val();
    var rotation = jQuery(".door_1 .rotation-input").val();
    var rotation = rotation.replace(/°/g, "");
  }

    if (left + width > canvas.width || top + height > canvas.height || left < 0 || top < 0) {
        return; // Prevent updating if the new position is out of bounds
    }

  var properties = {width, height, left, top, rotate: rotation};
  if (isSecondDoor) {
    addOrUpdateDoor(properties, 1); 
  } else {
    addOrUpdateDoor(properties, 0); 
  }
}
jQuery(document).on('click', '.toggleButton', function (e) {
  var get_stage = $(this).attr("step");
  return step_validation(get_stage);
});

jQuery(document).on("click", ".sid-btn-add-to-cart-btn", function(event) {
  event.preventDefault();
  
  // Show loading indicator
  showLoading();

  var quantities = [
      {
          variantId: $("#quantity-tile").data("variant-id"),
          quantity: parseInt($("#quantity-tile").val()),
          properties: gatherProperties('tiles')
      },
      {
          variantId: $("#quantity-corner").data("variant-id"),
          quantity: parseInt($("#quantity-corner").val()),
          properties: gatherProperties('corners')
      },
      {
          variantId: $("#quantity-edges").data("variant-id"),
          quantity: parseInt($("#quantity-edges").val()),
          properties: gatherProperties('edges')
      },
      {
          variantId: $("#hire_tile_cutter").data("variant-id"),
          quantity: parseInt($("#days_rent").val()),
          properties: gatherProperties('tile_cutter')
      },

  ];

  var itemsToAdd = quantities.filter(function(item) {
      return item.quantity > 0;
  });

  create_image();

  uploadBase64Image(selected_items['sid-design']).then((url) => {

    itemsToAdd.forEach(item => {
      item.properties.image = url;
    });

    if (itemsToAdd.length > 0) {
      addItemsToCart(itemsToAdd).then(() => {
        // Hide loading indicator after all operations are complete
        hideLoading();
      });
    } else {
      // Hide loading indicator if there are no items to add
      hideLoading();
    }
  }).catch(error => {
    console.error('Error uploading image:', error);
    hideLoading(); // Hide loading indicator in case of an error
  });
});

async function uploadBase64Image(base64Image) {
  const cloudName = 'dgh9rk4fx';
  const apiKey = '251573872432155';
  const apiSecret = '14YDl3Zrz3jHkFDV46F_roZPDyw';
  const timestamp = Math.floor(Date.now() / 1000);

  const signature = createSignature({
    timestamp: timestamp,
    upload_preset: 'custom',
  }, apiSecret);

  const formData = new FormData();
  formData.append('file', base64Image);
  formData.append('api_key', apiKey);
  formData.append('timestamp', timestamp);
  formData.append('upload_preset', 'custom');
  formData.append('signature', signature);

  const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
    method: 'POST',
    body: formData
  });
  const data = await response.json();
  if (response.ok) {
    return data.secure_url;
  } else {
    throw new Error(data.error.message);
  }
}

function createSignature(params, apiSecret) {
  const sortedParams = Object.keys(params).sort().map(key => `${key}=${params[key]}`).join('&');
  return CryptoJS.SHA1(sortedParams + apiSecret).toString();
}

function gatherProperties(prefix) {
  var properties = {};
  if(prefix == 'tile_cutter') {
    var this_id = $(this).attr("data_attr_id");
  } else {
    var hexFields = $("input[name^='" + prefix + "_hex_']");
    hexFields.each(function(index) {
        var this_id = $(this).attr("data_attr_id");
        var hexValue = $(this).val();
        var qtyValue = $("input[name='" + prefix + "_qty_[" + this_id + "]']").val();
        var nameValue = $("input[name='" + prefix + "_name_[" + this_id + "]']").val();
        
        properties['Item # ' + (index + 1)] = "Hex: " + hexValue + " QTY: " + qtyValue + " Color: " + nameValue ;
        properties['Name'] = jQuery("#sid_Name").val();
        properties['Email'] = jQuery("#sid_Email").val();
        properties['Phone'] = jQuery("#sid_Phone").val();
        properties['Postal'] = jQuery("#sid_Postal").val();
        properties['Address'] = jQuery("#address").val();
    });
  }
  return properties;
}

async function addItemsToCart(items) {
  for (let item of items) {
      try {
          await $.ajax({
              url: '/cart/add.js',
              method: 'POST',
              data: JSON.stringify({
                  id: item.variantId,
                  quantity: item.quantity,
                  properties: item.properties
              }),
              contentType: 'application/json',
              dataType: 'json'
          });
      } catch (error) {
          console.error('Error adding item to cart:', error);
      }
  }

  // Redirect to cart after adding all items
  window.location.href = '/cart';
}


function hideLoading() {
  // Implement this function to hide the loading indicator
  jQuery('.loading-overlay').hide();
}


jQuery(document).ready(function(){

    $('.door-rotation').on('input change', function() {
        var index = $(this).attr('name').includes('first') ? 0 : 1;
        var rotation = parseInt($(this).val());
    jQuery(".rotation-input").val(rotation+'°');
        var door = doorsOnCanvas[index];
        if (door) {
            updateDoorRotationAndPosition(door, rotation, index);
        }
    });
  if(validate_browser()){
    init_global_vars();
    init_stage();
    init_actions();
    load_step(1);
    update_color_fill_list();
  }
});




function validate_browser(){
  if(navigator.userAgent.indexOf('MSIE')>-1 || navigator.userAgent.indexOf('Trident/')>-1 || navigator.userAgent.indexOf('Edge/')>-1){
    jQuery('.msg').html('This tool doesn\'t support Internet Explorer. Please use a different browser');
    jQuery('.alert, .blocker').show(10);
    jQuery('#application').hide();
    return false;
  }
  return true;
}


function init_stage(){
  drawing_container = new createjs.Container();
  if(stage !== null){
    stage.autoClear=true;
    var screen_width = jQuery(window).width();
    stage.canvas.width = ((screen_width>=media_limit)?screen_width*.65:screen_width);
    var screen_height = jQuery(window).height();
    stage.canvas.height = ((screen_width>=media_limit)?screen_height*.90:400);
    stage.enableMouseOver(100);
    square = new Image();
    square.src = data.img.back_square;
  }
}

function zoom_level_fix(){
  var real_points = selected_type.real_points;
  var scale_current = calc_scale();
  var process_scale = parseFloat(scale.attr("data-previous"));
  var process_step = parseFloat(scale.attr("step"));
  var center = calc_center(resize_points);
  if(stage.canvas.height > 400){
    process_step*=-1;
  }
  
  if(!custom_design_imported){
      while(process_scale > 1 && process_scale < 3){
        var scale_previous = calc_scale_number(process_scale);
        var resize_points = scale_points(real_points, scale_previous, scale_current);
        center = calc_center(resize_points);
        if(scale_off_limits(center)){
          break;
        }else{
          process_scale += process_step;
        }
      }
      scale.val(process_scale);     
  }

  scale.change();
}


jQuery(document).on("blur", ".non-tile-field", function(){

  let areaId = jQuery(this).attr('none_tile_area');

  switch(unit_system){
    case "metric":
      // jQuery(this).val(imperial_numbert_to_format(jQuery(this).val()));
    break;
    case "centimeter":
      jQuery(this).val(imperial_numbert_to_format_centimeter(jQuery(this).val()));
    break;
    case "inches":
      jQuery(this).val(imperial_numbert_to_format_inches(jQuery(this).val()));
    break;
    case"imperial":
    default:
      jQuery(this).val(imperial_numbert_to_format(jQuery(this).val()));
    break;
  }

  render_non_tile_area(areaId, this);

});
function init_actions(){

  stage.on("stagemousedown", function(evt) {
    stage_click = true;
  });
  stage.on("stagemouseup", function(evt) {
    stage_click = false;
  });
  
  

  unit_system_actions();
  menu_li_actions();
  scale_action();
  colors_pattern();
  color_selection();
  tile_action();
  resize_canvas();
  none_tile_areas_action();
  initDoorUI();
  custom_color_action();
  step_skip();
}


function room_type_fields(type){
  jQuery('.sid-room-dimension').hide();
  switch (type) {
    case "rectangle":
      jQuery('.sid-rect').show();
    break;
    case "tl_l_shape":
    case "tr_l_shape":
    case "bl_l_shape":
    case "br_l_shape":
      jQuery('.sid-l-shape').show();
    break;
    case "l_t_shape":
    case "t_t_shape":
    case "b_t_shape":
    case "r_t_shape":
      jQuery('.sid-t-shape').show();
    break;
  }
}

function getTileTypeIndex(name){
  var types = data.tiles.types;
  var cont = 0;
  for(var type_name in types){
    if(type_name == name){
      return cont;
    }
    cont++;
  }
}

function init_global_vars(){
  stage = new createjs.Stage('sid-designed-canvas');
  canvas_container = new createjs.Container();
  createjs.Touch.enable(stage);
  
  canvas = jQuery("#sid-designed-canvas");
  scale = jQuery("#scale");
  unit_system = jQuery("#unit_system");
  room_size = jQuery(".room_area");
  colors = jQuery(".colors");
  report = jQuery("#sid-report");
  none_tile_areas_container = jQuery("#non-tile-area-list");
  
  edges_type = jQuery(".edges");
  edges_colors = jQuery(".edges_colors");
  
  width = jQuery("#width");
  height = jQuery("#height");
}

function init_process_vars(){
  none_tile_poligons = new createjs.Container();
  matriz = {};
  edges_and_corners = {};
  selected_type.none_tiles_areas = [];
  design_name = "";
}


function resizecanvas_action(cont){
  if(cont==resize_cont){
    resize_cont=0;
    var w = jQuery(window);
    var screen_width = w.width();
    var screen_height = w.height();
    var desktop = screen_width>=media_limit;
    if(desktop){
      // jQuery("#unit_system").removeClass("btn-group").addClass("btn-group-vertical");
    }else{
      // jQuery("#unit_system").removeClass("btn-group-vertical").addClass("btn-group");
    }

    load_step(current_stage);
    stage.update();
  }
}

function step_skip(){
  jQuery(".step_skip").click(function(){
    var este = jQuery(this);
    var step = este.attr("data-step");
    
    load_step(step);
  });
}

function custom_color_action(){
  jQuery("#custom_design").click(function(){
    jQuery("#pattern_container").ddslick('select', {index: "0"});
    jQuery("#color-primary").ddslick('select', {index: "0"});
    jQuery("#color-custom").ddslick('select', {index: "5"});
    
    load_step(5);
  });
}

function layers_reload(keep_data){
  create_matrix(keep_data);
  fill_edges_and_corners(keep_data);
}

function resize_canvas(){
  resize_cont = 0;
  jQuery(window).resize(function(){
    resize_cont++
    setTimeout(resizecanvas_action, 500, resize_cont);
  });
  resizecanvas_action(0);
}


function unit_system_actions(){
  var container = jQuery("#unit_system input[type='radio']");
  container.click(function(){
    unit_system = jQuery(this).val();
    if(selected_type != undefined){
      init_dimentions();
    }
  });
  container[0].click();
}

function init_dimentions(){
  var dimensions = data.defaul_dimentions;
  var array_data = [width, height];
  for(var dimention_position in array_data){
    var dimention = array_data[dimention_position];
    dimention.value = dimensions[unit_system].measure;
    dimention.min = dimensions[unit_system].min;
    dimention.max = dimensions[unit_system].max;
    dimention.step = dimensions[unit_system].step;
  }
  layers_reload(true);
  draw_with_drag_layer();
}

function colors_pattern(){
  
  
  var patterns = data.patterns;
  for(var patterns_position in patterns){
    var p = patterns[patterns_position];
  }
}

function color_selection(){
  var colors_available = data.tiles.colors.tiles;
  var keys = Object.keys(colors_available).sort();
  color_images = {};
  for(var color_position in keys){
    var color = keys[color_position];
    var code = colors_available[color];
    if (typeof code !== "undefined"){

        if(!code.startsWith("#")){
          var image = new Image();
          image.src = code;
          color_images[code] = image;
        }
    
    }
  }
  
  jQuery("#color-primary, #color-secondary, #color-custom, #edges-color, #corners-color").each(function(){
    var este = jQuery(this);
    var id = este.attr("id");
    este.find(".dd-option").each(function(){
      var option = jQuery(this);
      var code = option.children(".dd-option-value").val();
      var img = option.find(".dd-option-image")
        .css("border", "2px solid")
        .css("border-radius", "8px");
      if(code.startsWith("#")){
        img.css("background-color", code);
      }else{
        img.css("background-image", "url('img/colors/" + code + "')");
      }
    });
  });
  
  
  var edges = data.tiles.edges;
  for(var edge_position in edges){
    var edge = edges[edge_position];
  }
  
}

function hide_not_available_colors(not_available_colors, select){
  var option_selector = select.find("option");
  for(var not_available_color_position in not_available_colors){
    var not_available_color = not_available_colors[not_available_color_position];
    option_selector.filter("[color='" + not_available_color + "']").hide().addClass("not_available");
  }
  select.each(function(){
    var este = jQuery(this);
    var val = este.val();
    if(val != undefined){
      var option = este.find(".color_container[value='" + val + "']");
      if(option.hasClass("not_available")){
        var new_val = colors.children().not(".not_available").first().val();
        este.val(new_val).change();
      }
    }
  });
}

function normal_load_action(){
  clear_stage();
  draw_layer_cero();
  stage.update();
}

jQuery(document).on("click","#rotate_this",function(){
    showLoading();

    // Create a Promise to handle the sequence
    new Promise((resolve) => {
      // Resolve immediately to let the browser render the loading overlay
      setTimeout(resolve, 0);
    }).then(() => {
    var nametype = '';
    if(selected_type.type == 'tl_l_shape') {
      nametype = 'tr_l_shape';
    } else if(selected_type.type == 'tr_l_shape') {
      nametype = 'br_l_shape';
    }  else if(selected_type.type == 'br_l_shape') {
      nametype = 'bl_l_shape';
    } else if(selected_type.type == 'bl_l_shape') {
      nametype = 'tl_l_shape';
    } else if(selected_type.type == 'l_t_shape') {
      nametype = 't_t_shape';
    } else if(selected_type.type == 't_t_shape') {
      nametype = 'r_t_shape';
    } else if(selected_type.type == 'r_t_shape') {
      nametype = 'b_t_shape';
    } else if(selected_type.type == 'b_t_shape') {
      nametype = 'l_t_shape';
    }
    load_step(1);
    jQuery("#sid-loaded-custom-design").attr("loaded","0");
    custom_design_imported = false;
    var type =  nametype;
    room_type_fields(type);
    selected_type = data.types[type];
    init_dimentions();
    init_process_vars();
    load_step(2);
    zoom_level_fix();
    refresh_door();
    real_points_reset = JSON.parse(JSON.stringify(selected_type.real_points));
    jQuery("#unit_system_metric").click();
    hideLoading();
  });
});

function refresh_door() {
  
    $(".door-rotation").val(0);
    $(".rotation-input").val('0°');


    $("#first_door_width").val('');
    $("#first_door_left").val('');
    $("#first_door_top").val('');
    $("#first_door_rotation").val(0);
  
    $("#second_door_width").val('');
    $("#second_door_left").val('');
    $("#second_door_top").val('');
    $("#second_door_rotation").val(0);
  $(".add_door_class").removeClass("border-black2");
}
function tile_action(){
  var tiles = data.tiles.types;
  var tile_selector = jQuery(".tile");
  
  tile_images = {};
  for(var t_position in tiles){
    var t = tiles[t_position];

    var image = new Image();
    image.src = t.pattern;
    tile_images[t_position] = image;
  }
  
  jQuery(document).on("click",".sid-primary-tile-color input[type='radio']",function(){

    var color_id = jQuery(this).parent().parent().attr('id');
    
    var tile_id = color_id.replace("color", "tile");
    // if(tile_id != "tile-custom"){
      layers_reload(false);
    // }
    normal_load_action();

  });

  jQuery(document).on("click",".sid-tile input[type='radio']",function(){
    
    tile_update();    

  });


}

function tile_update() {
  var id = jQuery(this).parent().parent().parent().attr('id');
  
  if(id == undefined) {
    id = "tile-primary";    
  }

  
    if(id != "tile-custom"){
    layers_reload(true);
  }
  normal_load_action();
}
function get_not_available_color_values(not_available){
  var values = [];
  var colors = data.tiles.colors;
  for(var not_available_position in not_available){
    var not_available_item = not_available[not_available_position];
    values.push(colors[not_available_item]);
  }
  return values;
}

function format_number_measure(measure, small){
  switch(unit_system){
    case("metric"):{
      if(small){
        return parseInt(measure*100) + " cm";
      }else{
        return parseFloat(measure).toFixed(3) + " m";
      }
    }
    case("centimeter"):{
      return parseInt(measure*100) + " cm";
    }
    case("inches"):{
      return parseInt(measure*39.3701) + " inches";
    }
    case("imperial"):
    default:{
      var feet = parseInt(measure);
      var inches = parseInt(12*(measure-feet));
      if(small){
        return ((feet*12)+(inches)) + "\"";
      }else{
        return feet + "'" + (inches) + "\"";
      }
    }
  }
}

function none_tile_areas_action(){
  jQuery("#none_tile_area_add").click(function(){
    selected_type.none_tiles_areas.push(none_tile_areas_create());
    normal_load_action();
  });
}


function clear_stage(){
  canvas_container.removeAllChildren();
}

function scale_change(current, previous){
  scale.attr("data-previous", previous);
  scale.val(current);
  scale_action_change();
}
function scale_action(){
  jQuery(".zoom-step").click(function(){
    custom_design_imported = false;
    var step = jQuery(this).attr("step");
    step = parseFloat(step);
    var val = scale.val();
    val = parseFloat(val);
    scale_change(val+step, val);
  });
  jQuery(".workspace_measure").on('change blur',function(){ 
    if(selected_type != undefined){
      if(jQuery(this).attr('length') && jQuery(this).attr('length') == "1") {
        if(jQuery(this).attr('axis') == 'x'){

          width.val(jQuery(this).val());

        } else if(jQuery(this).attr('axis') == 'y'){

          height.val(jQuery(this).val());

        }
      }
      var units = get_units();
      var max = data.defaul_dimentions.imperial.max;
      var current_scale = calc_scale();

      if((units.width && units.height) && (units.width <= max && units.height <= max)){
        var previous_start = jQuery(this).attr('start');
        var previous_finish = jQuery(this).attr('finish');
        var current_dim = jQuery(this).val();
        var custom_unit_x = 0;
        var custom_unit_y = 0;
        
        var real_points = selected_type.real_points;
        var center_real_points = calc_center(real_points);
        var resize_points = {};
        
        if(jQuery(this).attr('length') && jQuery(this).attr('length') != "1") {
          
          
          switch(unit_system){
            case("metric"):{
              current_dim = calc_meters("to", current_dim);
              break;
            }
            case("centimeter"):{
              current_dim = calc_meters("to", current_dim);
              current_dim = parseFloat(current_dim*39.3701).toFixed(3);
              break;
            }
            case("inches"):{
              current_dim = calc_meters("to", current_dim);
              current_dim = parseFloat(current_dim*39.3701).toFixed(3);
              break;
            }
            case("imperial"):
            default:{
              current_dim = get_unit_imperial(current_dim);
              break;
            }
          }

          var current_unit = parseFloat(current_dim)*current_scale;

          var condition_value = 0;
          if(parseFloat(previous_finish) > parseFloat(previous_start)) {
            custom_unit_x = current_unit - (parseFloat(previous_finish) - parseFloat(previous_start));
            custom_unit_y = current_unit - (parseFloat(previous_finish) - parseFloat(previous_start));
            condition_value = parseFloat(previous_start);
          } else {
            custom_unit_x = current_unit - (parseFloat(previous_start) - parseFloat(previous_finish));
            custom_unit_y = current_unit - (parseFloat(previous_start) - parseFloat(previous_finish));
            condition_value = parseFloat(previous_finish);
          }

          
          for(var point_position in real_points){
            var point = real_points[point_position];
            var new_point = {
              x: (jQuery(this).attr('axis') == 'x' && condition_value < point.x) ? point.x + custom_unit_x : point.x,
              y: (jQuery(this).attr('axis') == 'y' && condition_value < point.y) ? point.y + custom_unit_y : point.y
            }
            resize_points[point_position] = new_point;
          }
            

        } else {
          var width_unit = units.width*current_scale;
          var height_unit = units.height*current_scale;
          
          var factor_width = width_unit/center_real_points.width;
          var factor_height = height_unit/center_real_points.height;
          for(var point_position in real_points){
            var point = real_points[point_position];
            var new_point = {
              x: point.x*factor_width
              , y: point.y*factor_height
            }
            resize_points[point_position] = new_point;
          }
        }

        selected_type.real_points = resize_points;
        
        layers_reload(true);
        draw_with_drag_layer();
        var center = calc_center(resize_points);
        if(scale_off_limits(center)){
          var width_units = center.width/current_scale;
          var height_units = center.height/current_scale;
          var val = scale.val();
          val = parseFloat(val);
          var center_off_limits = {
            width: center.width
            , height: center.height
          }
          var cont = 0;
          while(scale_off_limits(center_off_limits)){
            cont+=.25;
            var factor = data.scale/(val+cont);
            center_off_limits = {
              width: width_units*factor
              , height: height_units*factor
            }
          }
          scale_change(val+cont, val);
        }
      }else if(units.width <= max || units.height <= max){
      }
    }
  }).keyup(function(){
    var este = jQuery(this);
    este.removeAttr("style");
    switch(unit_system){
      case("metric"):{
        if(!isNumber(este.val())){
          este.css("box-shadow", "0px 0px 10px 1px red");
        }
        break;
      }
      case("centimeter"):{
        if(!isNumber(este.val())){
          este.css("box-shadow", "0px 0px 10px 1px red");
        }
        break;
      }
      case("inches"):{
        if(!isNumber(este.val())){
          este.css("box-shadow", "0px 0px 10px 1px red");
        }
        break;
      }
      case("imperial"):
      default:{
        if(imperial_format_to_decimal(este.val()) == false){
          este.css("box-shadow", "0px 0px 10px 1px red");
        }
        break;
      }
    }
  });
}

function scale_action_change(){
  if(selected_type != undefined){
    var real_points = selected_type.real_points;
    var center_real_points = calc_center(real_points);
    var scale_current = calc_scale();
    var scale_previous = calc_scale_previous();
    var resize_points = scale_points(real_points, scale_current, scale_previous);
    var center = calc_center(resize_points);
    if(scale_off_limits(center)){
      scale.val(scale.attr("data-previous"));
    }else{
      jQuery(".workspace_measure").removeAttr("style");
      var none_tile_points = selected_type.none_tiles_areas;
      if(!scale_changed){
        scale_changed = false;
        for(var none_tile_position in none_tile_points){
          var none_tile_point = none_tile_points[none_tile_position];
          none_tile_point.points = scale_points(none_tile_point.points, scale_current, scale_previous);
          none_tile_points[none_tile_position] = none_tile_point;
        }
      }
      if(!custom_design_imported) {
        selected_type.real_points = resize_points;
      }
      layers_reload(true);
      draw_with_drag_layer();
    }
    jQuery("#second_door_left").trigger("change");
    jQuery("#first_door_left").trigger("change");
  }
}

function scale_off_limits(center){
  var margin = data.margin*3;
  return center.height > stage.canvas.height-margin || center.width > stage.canvas.width-margin;
}

function scale_points(real_points, scale_current, scale_previous){
  var resize_points = {};
  for(var point_position in real_points){
    var point = real_points[point_position];
    var new_point = {
      x: (point.x/scale_previous)*scale_current
      , y: (point.y/scale_previous)*scale_current
    }
    resize_points[point_position] = new_point;
  }
  return resize_points;
}

function get_units(){
  var unit_width = width.val();
  var unit_height = height.val();
  
  switch(unit_system){
    case("metric"):{
      unit_width = calc_meters("to", unit_width);
      unit_height = calc_meters("to", unit_height);
      break;
    }
    case("centimeter"):{
      unit_width = parseFloat(calc_meters("to", unit_width)*100).toFixed(3) + "cm";
      unit_height = parseFloat(calc_meters("to", unit_height)*100).toFixed(3) + "cm";
      break;
    }
    case("inches"):{
      unit_width = parseFloat(calc_meters("to", unit_width)*39.3701).toFixed(3) + "cm";
      unit_height = parseFloat(calc_meters("to", unit_height)*39.3701).toFixed(3) + "cm";
      break;
    }
    case("imperial"):
    default:{
      unit_width = get_unit_imperial(unit_width);
      unit_height = get_unit_imperial(unit_height);
      break;
    }
  }
  return {
    width: parseFloat(unit_width),
    height: parseFloat(unit_height)
  };
}

function get_unit_imperial(value){
  if(!isNumber(value)){
    value = imperial_format_to_decimal(value);
  }
  return value;
}

function load_step(step){

  previous_stage = current_stage;
  current_stage = step;
  
  if(current_stage != previous_stage){
    
    if(current_stage==1){
      jQuery(".sid-canvas .sid-designed-home").show();
      jQuery(".sid-canvas .sid-wrapper").hide();
    }else{
      jQuery(".sid-canvas .sid-wrapper").show();
      jQuery(".sid-canvas .sid-designed-home").hide();
    }
    
    if(!current_stage){
      current_stage = 1;
    }
    var targetDiv = $('.roomSizeDiv[data-stage="' + current_stage + '"]');
    if (targetDiv.hasClass('visible')) {
      // targetDiv.removeClass('visible');
      // $(this).find(".change-up").removeClass("fa-caret-up").addClass("fa-caret-down");
    } else {
      $('.roomSizeDiv').removeClass('visible');
      $('.roomSizeDiv').find(".change-up").removeClass("fa-caret-up").addClass("fa-caret-down");
  
      targetDiv.addClass('visible');
      $(this).find(".change-up").removeClass("fa-caret-down").addClass("fa-caret-up");
      load_step(current_stage);
    }
    window["load_stage_" + current_stage]();
  }
}



function menu_li_actions(){
  jQuery("button.sid-step-link, .sid-step-info").click(function(){
    let step = jQuery(this).parent().attr("step");
    return step_validation(step);
  });

}


function loadDesignFromoLocalStorage() {
    
  selected_type = JSON.parse(localStorage.getItem("selected_type"));
  
  edges_and_corners = JSON.parse(localStorage.getItem("edges_and_corners"));
  scale.val(localStorage.getItem("scale"));
  scale.attr("data-previous", localStorage.getItem("scale_previous"));
  matriz_data = JSON.parse(localStorage.getItem("matriz"));
  custom_tile_data = JSON.parse(localStorage.getItem("custom_tile_data"));
  
  scale_changed = true;
  custom_design_imported = true; 
  
  jQuery("#" + localStorage.getItem("primary_tile") ).attr('checked',true);
  jQuery("#" + localStorage.getItem("primary_color") ).attr('checked',true);
  
  matriz_changed = true;
  none_tile_poligons = new createjs.Container();
  current_stage = parseInt(localStorage.getItem("current_stage"));
  previous_stage = parseInt(localStorage.getItem("previous_stage"));
  room_type_fields(selected_type.type);
  if(current_stage != previous_stage){
    
    if(current_stage==1){
      jQuery(".sid-canvas .sid-designed-home").show();
      jQuery(".sid-canvas .sid-wrapper").hide();
    }else{
      jQuery(".sid-canvas .sid-wrapper").show();
      jQuery(".sid-canvas .sid-designed-home").hide();
    }
    
    load_step(current_stage);
    zoom_level_fix();
  }
  
  jQuery("#unit_system_" + localStorage.getItem("unit_system")).click();

  scale_action_change();
  
}


function step_validation(step){
  if(current_stage != 1){
    load_step(step);
    return true;
  }else{
    jQuery('.msg').html('<strong>Warning!</strong><br>Please select a room shape to begin');
    jQuery('.alert, .blocker').show(10);
    return false;
  }
}


function draw_layer_drag(){
  var drags_data = selected_type.drags["step" + current_stage];
  var group = new createjs.Container();
  var image;
  var dif = 20;
  if(drags_data != undefined){
    var points = selected_type.real_points;
    var margin = data.margin;
    
    var buttons = drags_data.buttons;
    var hide = [];
    for(var point_position in buttons){
      var button = buttons[point_position];
      var b_points = button.points;
      var b_base = null;
      var match = true;
      var b_hide = [];
      var b_hide_points = [];
      for(var b_point_position in b_points){
        var b_point = points[b_point_position];
        if(b_base == null){
          b_base = b_point;
          b_hide.push(b_point_position);
          b_hide_points.push(points[b_point_position]);
        }else{
          if(
            b_base.x >= b_point.x-dif
            &&
            b_base.x <= b_point.x+dif
            && 
            b_base.y >= b_point.y-dif
            &&
            b_base.y <= b_point.y+dif
          ){
            b_hide.push(b_point_position);
            b_hide_points.push(points[b_point_position]);
          }else{
            match = false;
            break;
          }
        }
      }
      
      if(match){
        
        var fix = {
          x: "max_x"
          ,y: "max_y"
        }
        switch(button.type){
          case("inner_0-90"):{
            fix.x = "min_x";
            break;
          }
          case("inner_90-180"):{
            fix.y = "min_y";
            fix.x = "min_x";
            break;
          }
          case("inner_180-270"):{
            fix.y = "min_y";
            break;
          }
          case("inner_270-360"):{
            break;
          }
          case("outter_0-90"):{
            fix.x = "min_x";
            break;
          }
          case("outter_90-180"):{
            fix.y = "min_y";
            fix.x = "min_x";
            break;
          }
          case("outter_180-270"):{
            fix.y = "min_y";
            break;
          }
          case("outter_270-360"):{
            break;
          }
        }
        var fix_center = calc_center(b_hide_points);
        fix.x = fix_center[fix.x];
        fix.y = fix_center[fix.y];
        for(var b_hide_position in b_hide){
          var b_hide_value = b_hide[b_hide_position];
          points[b_hide_value] = jQuery.extend({},fix);
        }
        
        hide = hide.concat(b_hide);
        var url = siteURL + "img/drag_buttons/" + button.type + ".png";
        var desface = {x:0, y: 0}
        switch(button.type){
          case("outter_0-90"):{
            desface.y-=26;
            break;
          }
          case("inner_0-90"):{
            desface.y-=26;
            break;
          }
          case("inner_180-270"):{
            desface.x-=26;
            break;
          }
          case("inner_270-360"):{
            desface.x-=26;
            desface.y-=26;
            break;
          }
        }

        image = new Image();
        image.points = b_points;
        image.base = b_base;
        image.desface = desface;
        image.src = url;
        image.onload = function(event) {
          var image = event.target;
          var bitmap = new createjs.Bitmap(image);
          bitmap.x = image.base.x+margin+image.desface.x;
          bitmap.y = image.base.y+margin+image.desface.y;
          bitmap.on("pressup", function(evt) {
            drag_points_shoot(image.points, selected_type.real_points);
            layers_reload(false);
            draw_with_drag_layer();
          });
          bitmap.addEventListener("mouseover", function(e) {
            canvas.addClass("clickable");
          });
          
          bitmap.addEventListener("mouseout", function(e) {
            canvas.removeClass("clickable");
          });
          group.addChild(bitmap);
          stage.update();
        }
      }
    }
    
    var drags = drags_data.points;
    drag_measures = new createjs.Container();
    var factor = data.factor;
    for(var drag_position in drags){
      if(hide.indexOf(drag_position) == -1){
        var drag = drags[drag_position];
        var measures = drag.measures;
        var type = drag.type;
        var type_img = get_type_img(type);
        image = new Image();
        image.drag = drag;
        image.src = type_img;
        image.onload = function(event) {
          var image = event.target;
          var drag = image.drag;
          var bitmap = new createjs.Bitmap(image);
          
          var location = drag.location;
          var image_location = points[location.points[0]];
          var desface = get_gap(image.height);
          
          bitmap.x = image_location.x+margin+desface.x;
          bitmap.y = image_location.y+margin+desface.y;
          bitmap.desface = desface;
          
          bitmap.scaleX=0.06;
          bitmap.scaleY=0.06;
          
          bitmap.addEventListener("mouseover", function(e) {
            createjs.Touch.enable(stage);
            var bitmap = e.currentTarget;
            bitmap.scaleX=0.065;
            bitmap.scaleY=0.065;
            stage.update();
          });
          
          bitmap.addEventListener("mouseout", function(e) {
            var bitmap = e.currentTarget;
            bitmap.scaleX=0.06;
            bitmap.scaleY=0.06;
            stage.update();
          });
          
          bitmap.on("pressup", function(evt) {
            createjs.Touch.disable(stage);
            drag_measures.removeAllChildren();
            draw_with_drag_layer();
          });
          
          bitmap.on("pressmove", function(evt) {

            var bitmap = evt.target;
            var desface = bitmap.desface;
            var type = drag.type;
            var move = {
              x: evt.stageX
              , y: evt.stageY
            };
            if(drag_in_limits(drag.limits, move)){
              switch(type){
                case("x"):{
                  bitmap.x = move.x+desface.x;
                  break;
                }
                case("y"):{
                  bitmap.y = move.y+desface.y;
                  break;
                }
                case("xy"):{
                  bitmap.x = move.x+desface.x;
                  bitmap.y = move.y+desface.y;
                  break;
                }
              }
              
              var points = drag.points;
              var real_points = selected_type.real_points;
              
              for(var point_position in points){
                var point_axis = points[point_position];
                for(var axis_position in point_axis){
                  var axis = point_axis[axis_position];
                  real_points[point_position][axis] = move[axis]-margin;
                }
              }
              drag_measure(drag, real_points);
              layers_reload(false);
              draw_with_drag_layer();
            }
          });
          group.addChild(bitmap);
          stage.update();
        }
      }
    }
  }


  return group;
}

var wm = new createjs.Shape();

function draw_watermark() {
  
  var image = new Image();
  image.src = siteURL + "watermark-logo.png";
   
    image.onload=function(){

    stage.removeChild(wm);

      wm.graphics.clear()
        .beginBitmapFill(image);
    wm.graphics.drawRect(0,0,stage.canvas.width,stage.canvas.height); 

    stage.addChild(wm);
    stage.update();
    }

}

function drag_points_shoot(shoots, points){
  var scale = calc_scale();
  for(var shoot_positions in shoots){
    var shoot = shoots[shoot_positions];
    var point = points[shoot_positions];
    point[shoot.axis] += scale*shoot.distance;
  }
}
function drag_measure(drag, real_points){
  drag_measures.removeAllChildren();
  var scale_size = calc_scale();
  var measures = drag.measures;
  var margin = data.margin;
  for(var measure_position in measures){
      if(measures.hasOwnProperty(measure_position)){
    var measure = measures[measure_position];
    var axis = measure.axis;
    var start = real_points[measure.start][axis];
    var finish = real_points[measure.finish][axis];
    var lenght = Math.abs(finish-start);
    var measure_text = new createjs.Text(format_measure(lenght/scale_size), data.text.drag.font, data.text.drag.color);
    var point = real_points[measure.location.point];
    measure_text.x = point.x+margin;
    measure_text.y = point.y+margin;
    drag_measure_gap(measure_text, measure.location.position);
    drag_measures.addChild(measure_text);
      }
  }
}

function drag_measure_gap(measure_text, type){
  var space = 5;
  var bounds = measure_text.getBounds();
  switch(type){
    case("left_over"):{
      measure_text.x -= (bounds.width+space);
      measure_text.y -= (bounds.height+space);
      break;
    }
    case("left_under"):{
      measure_text.x -= (bounds.width+space);
      measure_text.y += space;
      break;
    }
    case("right_over"):{
      measure_text.x += space;
      measure_text.y -= (bounds.height+space);
      break;
    }
    case("right_under"):
    default:{
      measure_text.x += space;
      measure_text.y += space;
      break;
    }
  }
}

function get_gap(image_height){
  var gap = {
    x: 0
    , y: 0
  };
  switch(location.position){
    case("center"):{
      gap.x -= image_height/2;
      gap.y -= image_height/2;
      break;
    }
    case("over"):{
      gap.x -= image_height/4;
      gap.y -= image_height;
      break;
    }
    case("right"):{
      gap.y -= image_height/4;
      break;
    }
    case("under"):{
      gap.x -= image_height/4;
      
      break;
    }
    case("left"):{
      gap.x -= image_height;
      gap.y -= image_height/4;
      break;
    }
  }
  return gap;
}

function get_type_img(type){
  var type_img = "";
  switch(type){
    case("x"):{
      type_img += data.img.right_arrow;
      break;
    }
    case("y"):{
      type_img += data.img.down_arrow;
      break;
    }
    case("xy"):{
      type_img += data.img.diagonal_arrow;
      break;
    }
  }
  return type_img;
}

function drag_in_limits(limits, move){
  var result = true;
  var margin = data.margin;
  var real_points = selected_type.real_points;
  if(
    move.x >= margin
    && move.y >= margin
    && move.x <= stage.canvas.width-margin
    && move.y <= stage.canvas.height-margin
    ){
    for(var limit_position in limits){
        if(limits.hasOwnProperty(limit_position)){
      var limit = limits[limit_position];
      var real_point_limit = real_points[limit.point][limit.axis];
      switch(limit.not){
        case("under"):{
          result = (move[limit.axis]-margin) <= real_point_limit?false:true;
          break;
        }
        case("over"):{
          result = (move[limit.axis]-margin) >= real_point_limit?false:true;
          break;
        }
        case("both"):{
          result = true;
          break;
        }
      }

      if(!result){
        break;
      }
        }
    }
  }else{
    result = false;
  }
  return result;
}


function none_tile_areas_create(){
  var current_scale = calc_scale()*2;
  var original_points = data.none_tile_area.points;
  var new_none_tile_area = {
    points: []
    , measures: false
  };
  var get_x = selected_type.real_points[0].x;
  var get_y = selected_type.real_points[0].y;
  var assign_x1 = 0;
  var assign_x2 = 0;
  var assign_y1 = 0;
  var assign_y2 = 0;
  if(selected_type.type == 'br_l_shape' || selected_type.type == 'r_t_shape' || selected_type.type == 'b_t_shape') {
    if(get_x == 0) {
      assign_x1 = 1;
      assign_x2 = 0;
    } else {
      assign_x1 = get_x / 57.6;
      assign_x2 = assign_x1 + 1;
    }
    if(get_y == 0) {
      assign_y1 = 1;
      assign_y2 = 0;
    } else {
      assign_y1 = get_y / 57.6;
      if(selected_type.type == 'r_t_shape') {
        assign_y2 = assign_y1 - 1;
      } else {
        assign_y2 = assign_y1 + 1;
      }
    }
  } else {
    assign_x1 = 1;
    assign_x2 = 0;
    assign_y1 = 1;
    assign_y2 = 0;
  }

  original_points = {
        "0": {"x": assign_x1, "y": assign_y1},
        "1": {"x": assign_x1, "y": assign_y2},
        "2": {"x": assign_x2, "y": assign_y2},
        "3": {"x": assign_x2, "y": assign_y1}
    };
  for(var point_position in original_points){
    var point = original_points[point_position];
    var new_point = {
      x: (point.x*current_scale)
      , y: (point.y*current_scale)
    }
    new_none_tile_area.points.push(new_point);
  }
  return new_none_tile_area;
}

function draw_none_tile_areas(){
  none_tile_poligons.removeAllChildren();
  var figures = selected_type.none_tiles_areas;
  var margin = data.margin;
  none_tile_poligons.x = margin;
  none_tile_poligons.y = margin;
  none_tile_areas_container.empty();
  
  for(var figure_position in figures){
    
    var figure = figures[figure_position];
    if(!(figure && figure.points && typeof figure.points[0] !== "undefined")){
      continue;
    }
    var none_tile = draw_none_tile_poligon(figure);
    none_tile.figure = figure;
    if(current_stage==4){
      if(figure.measures){
        var center = calc_center(figure.points);
        var scale_size = calc_scale();
        
        var width = new createjs.Text(format_measure(center.width/scale_size), "bold " + data.text.measures.font, data.text.measures.color);
        width_bounds = width.getBounds();
        width.x = center.max_x-width_bounds.width;
        width.y = center.max_y+5;
        none_tile_poligons.addChild(width);
        
        var height = new createjs.Text(format_measure(center.height/scale_size), "bold " + data.text.measures.font, data.text.measures.color);
        height_bounds = height.getBounds();
        height.x = center.max_x+5;
        height.y = center.max_y-height_bounds.height;
        none_tile_poligons.addChild(height);
      }
      
      var drag = data.none_tile_area.drags;
      var type_img = get_type_img("xy");
      var image = new Image();
      image.drag = drag;
      image.figure = figure;
      image.src = type_img;
      image.onload = function(event) {
        var image = event.target;
        var drag = image.drag;
        var figure = image.figure;
        var bitmap = new createjs.Bitmap(image);
        
        var location = drag.location;
        var image_location = figure.points[location.points[0]];
        var desface = get_gap(image.height);
        
        bitmap.x = image_location.x+desface.x;
        bitmap.y = image_location.y+desface.y;
        bitmap.desface = desface;
        
        bitmap.scaleX=0.06;
        bitmap.scaleY=0.06;
        
        bitmap.addEventListener("mouseover", function(e) {

          createjs.Touch.enable(stage);
          var bitmap = e.currentTarget;
          bitmap.scaleX=0.065;
          bitmap.scaleY=0.065;
          stage.update();
        });
        
        bitmap.addEventListener("mouseout", function(e) {
          var bitmap = e.currentTarget;
          bitmap.scaleX=0.06;
          bitmap.scaleY=0.06;
          stage.update();
        });
        
        
        bitmap.on("pressup", function(evt) {
          createjs.Touch.disable(stage);
          figure.measures=false;
          drag_measures.removeAllChildren();
          normal_load_action();
        });
        var polygon = draw_selectd_type_real_points("rgba(255,255,255,1)");
        bitmap.on("pressmove", function(evt) {
          var bitmap = evt.target;
          var desface = bitmap.desface;
          var type = drag.type;
          var move = {
            x: evt.stageX
            , y: evt.stageY
          };
          var points = drag.points;
          var real_points = figure.points;
          var center = calc_center(real_points);
          center.min_x += margin;
          center.max_x += margin;
          center.min_y += margin;
          center.max_y += margin;
          
          var posible_points = {};
          for(var point_position in points){
            var point_axis = points[point_position];
            for(var axis_position in point_axis){
              var axis = point_axis[axis_position];
              if(posible_points[point_position] == undefined){
                posible_points[point_position] = {};
              }
              posible_points[point_position][axis] = move[axis];
            }
          }
          var center_posible_points = calc_center(posible_points);
          
          if(
            polygon.hitTest(center_posible_points.max_x, center_posible_points.min_y)
            && polygon.hitTest(center_posible_points.max_x, center_posible_points.max_y)
            && polygon.hitTest(center_posible_points.min_x, center_posible_points.max_y)
          ){
            bitmap.x = move.x+desface.x;
            bitmap.y = move.y+desface.y;
            for(var point_position in points){
              var point_axis = points[point_position];
              for(var axis_position in point_axis){
                var axis = point_axis[axis_position];
                real_points[point_position][axis] = move[axis]-margin;
              }
            }
            figure.measures=true;
            draw_none_tile_areas();
            stage.update();
          }
        }); 
        none_tile_poligons.addChild(bitmap);
        stage.update();
      }
    }
    
    none_tile.on("mouseover", function(evt) {
      createjs.Touch.enable(stage);
    });
    
    none_tile.on("pressup", function(evt) {
      createjs.Touch.disable(stage);
    });
    
    none_tile.on("pressmove", function(evt) {
      if(current_stage==4){
        var shape = evt.currentTarget;
        
        var new_base = {
          x: evt.stageX-margin
          , y: evt.stageY-margin
        }
        var polygon = draw_selectd_type_real_points("rgba(255,255,255,1)");
        var figure = shape.figure;
        var base = {
          x: evt.stageX
          , y: evt.stageY
        }
        var points = figure.points;
        var center = calc_center(points);
        var new_points = {
          0: {
            x: new_base.x+center.width
            , y: new_base.y
          }
          , 1: {
            x: new_base.x+center.width
            , y: new_base.y+center.height
          }
          , 2:{
            x: new_base.x
            ,y: new_base.y+center.height
          }
          , 3:{
            x: new_base.x
            , y: new_base.y
          }
        };
        var hit_pass = true;
        for(var point_position in new_points){
          var point = new_points[point_position];
          if(!polygon.hitTest(point.x+margin, point.y+margin)){
            hit_pass = false;
            break;
          }
        }
        if(hit_pass){
          figure.points=new_points;
          draw_none_tile_areas();
          stage.update();
        }
      }
    });
    none_tile_poligons.addChild(none_tile);
    none_tile_areas_container.append(create_none_tile_div(figure_position));
  }
  none_tile_area_remove();
}

function draw_none_tile_poligon(figure){
  
  var none_tile = new createjs.Shape();
  var margin = 0;
  var graphics = none_tile.graphics;
  var points = figure.points;

  var first = points[0];
  var real_points = {};
  graphics.beginStroke(data.colors.none_tile_border);
  graphics.beginFill(data.colors.none_tile_fill);
  for(var point_position in points){
    var point = points[point_position];
    var x = point.x;
    var y = point.y;
    real_points[point_position] = {
      x:x
      , y:y
    }
    graphics.lineTo((x+margin), (y+margin));
  }
  graphics.lineTo((first.x+margin), (first.y+margin));
  figure.points = real_points;
  return none_tile;
}

function none_tile_area_remove(){
  none_tile_areas_container.find(".btn-remove").click(function(){
    var position = jQuery(this).parent().attr("none_tile_area");
    selected_type.none_tiles_areas.splice(position,1);
    normal_load_action();
  });
}

function render_non_tile_area(figure_position){
  var current_scale = calc_scale();

  let nTop;
  let nLeft;
  let nWidth;
  let nHeight;  
  
  switch(unit_system){
    case("metric"):{
      nTop = parseFloat(calc_meters("to", jQuery("#non_tile_top_" + figure_position).val())) * current_scale;
      nLeft = parseFloat(calc_meters("to", jQuery("#non_tile_left_" + figure_position).val())) * current_scale;
      nWidth = parseFloat(calc_meters("to", jQuery("#non_tile_width_" + figure_position).val())) * current_scale;
      nHeight = parseFloat(calc_meters("to", jQuery("#non_tile_height_" + figure_position).val())) * current_scale;
      break;
    }
    case("centimeter"):{
      nTop = (parseFloat(parseFloat(calc_meters("to", jQuery("#non_tile_top_" + figure_position).val())) * current_scale) * 100).toFixed(3) + 'cm';
      nLeft = (parseFloat(parseFloat(calc_meters("to", jQuery("#non_tile_left_" + figure_position).val())) * current_scale) * 100).toFixed(3) + 'cm';
      nWidth = (parseFloat(parseFloat(calc_meters("to", jQuery("#non_tile_width_" + figure_position).val())) * current_scale) * 100).toFixed(3) + 'cm';
      nHeight = (parseFloat(parseFloat(calc_meters("to", jQuery("#non_tile_height_" + figure_position).val())) * current_scale) * 100).toFixed(3) + 'cm';
      break;
    }
    case("inches"):{
      nTop = (parseFloat(parseFloat(calc_meters("to", jQuery("#non_tile_top_" + figure_position).val())) * current_scale) * 39.3701).toFixed(3) + 'inches';
      nLeft = (parseFloat(parseFloat(calc_meters("to", jQuery("#non_tile_left_" + figure_position).val())) * current_scale) * 39.3701).toFixed(3) + 'inches';
      nWidth = (parseFloat(parseFloat(calc_meters("to", jQuery("#non_tile_width_" + figure_position).val())) * current_scale) * 39.3701).toFixed(3) + 'inches';
      nHeight = (parseFloat(parseFloat(calc_meters("to", jQuery("#non_tile_height_" + figure_position).val())) * current_scale) * 39.3701).toFixed(3) + 'inches';
      break;
    }
    case("imperial"):
    default:{
      nTop = parseFloat(get_unit_imperial(imperial_format_to_decimal(jQuery("#non_tile_top_" + figure_position).val()))) * current_scale;
      nLeft = parseFloat(get_unit_imperial(imperial_format_to_decimal(jQuery("#non_tile_left_" + figure_position).val()))) * current_scale;
      nWidth = parseFloat(get_unit_imperial(imperial_format_to_decimal(jQuery("#non_tile_width_" + figure_position).val()))) * current_scale;
      nHeight = parseFloat(get_unit_imperial(imperial_format_to_decimal(jQuery("#non_tile_height_" + figure_position).val()))) * current_scale;
      break;
    }
  }


  selected_type.none_tiles_areas[figure_position].points = [
    {x: nLeft + nWidth, y: nTop},
    {x: nLeft + nWidth, y: nTop + nHeight},
    {x: nLeft, y: nTop + nHeight},
    {x: nLeft, y: nTop}
  ];
  
  normal_load_action();
  
}

function create_none_tile_div(figure_position){
  var scale_size = calc_scale();
  
  var li = jQuery("<li>")
    .addClass("none_tile_area_element lineal sid-list")
    .attr("id","none_tile_area_" + figure_position)
    .attr("none_tile_area",figure_position);


  var SizeHeading = jQuery("<h1>").attr("style","width: 100%;");
  var divX = jQuery("<div>").addClass("sid-field-group sid-col-6");
  var divY = jQuery("<div>").addClass("sid-field-group sid-col-6");
  var PositionHeading = jQuery("<h1>").attr("style","width: 100%;");
  var divW = jQuery("<div>").addClass("sid-field-group sid-col-6");
  var divH = jQuery("<div>").addClass("sid-field-group sid-col-6");
  
  var points = selected_type.none_tiles_areas[figure_position].points;
  var center = calc_center(points);
  var area_points = {};
  for(point_position in points){
    var point = points[point_position];
    area_points[point_position] = {
      x: point.x-center.min_x
      ,y: point.y-center.min_y
    }
  }
  

  divW.append(jQuery('<label>')
    .attr("none_tile_area", figure_position)
    .html("Width"));
  divW.append(jQuery('<input>')
    .attr("type", 'text')
    .addClass('non-tile-field form-control')
    .attr("id", "non_tile_width_" + figure_position)
    .attr("none_tile_area", figure_position)
    .val(format_measure(center.width.toFixed(2)/scale_size).replace("m","")));
  divH.append(jQuery('<label>')
    .attr("none_tile_area", figure_position)
    .html("Length"));
  divH.append(jQuery('<input>')
    .attr("type", 'text')
    .addClass('non-tile-field form-control')
    .attr("id", "non_tile_height_" + figure_position)
    .attr("none_tile_area", figure_position)
    .val(format_measure(center.height.toFixed(2)/scale_size).replace("m","")));
  divX.append(jQuery('<label>')
    .attr("none_tile_area", figure_position)
    .html("X"));
  divX.append(jQuery('<input>')
    .attr("type", 'text')
    .addClass('non-tile-field form-control')
    .attr("id", "non_tile_left_" + figure_position)
    .attr("none_tile_area", figure_position)
    .val(format_measure(center.min_x.toFixed(2)/scale_size).replace("m","")));
  divY.append(jQuery('<label>')
    .attr("none_tile_area", figure_position)
    .html("Y"));
  divY.append(jQuery('<input>')
    .attr("type", 'text')
    .addClass('non-tile-field form-control')
    .attr("id", "non_tile_top_" + figure_position)
    .attr("none_tile_area", figure_position)
    .val(format_measure(center.min_y.toFixed(2)/scale_size).replace("m","")));

  SizeHeading.append("Size");
  PositionHeading.append("Position");
  li.append(SizeHeading);
  li.append(divW);
  li.append(divH);
  li.append(PositionHeading);
  li.append(divX);
  li.append(divY);
  var applyBtn = jQuery("<button>")
    .attr("type", "button")
    .addClass("sid-btn btn-apply")
    .html("Apply");
  li.append(applyBtn);
  var removeBtn = jQuery("<button>")
    .attr("type", "button")
    .addClass("sid-btn btn-danger btn-remove")
    .html("Remove");  
  li.append(removeBtn);

  return li;
}


function create_image(){
  var image = document.getElementById("sid-designed-canvas").toDataURL();
  selected_items['sid-design'] = image;
  
}

function refresh_report(){
  report.empty();
  var scale_size = calc_scale();
  
  var real_area = calc_area(selected_type.real_points)/(scale_size*scale_size);
  if(unit_system == "metric"){
    real_area*=data.convertion_factor;
  }
  
  if(matriz==null){
    normal_load_action();
  }
  
  create_image();
  
  var tiles_colors = calc_tiles();

  var num_tiles = 0;
  var tile_text = jQuery("<div>");
  var colors = data.tiles.colors.tiles;
  var product_ids = data.tiles.ids;

  selected_items['tiles_colors'] = tiles_colors;
  selected_items['colors'] = data.tiles.colors;
  selected_items['ids'] = data.tiles.ids;
  for(var tile in tiles_colors){
    if(Object.keys(tile).length > 0){
      var tile_type = jQuery("<div>").addClass("sid-primary-tile-title").html(tile);
      var tiles = tiles_colors[tile];
      for(var color in tiles){
        if(color != unset_color){
          jQuery("#custom-product-form").append("<input type='hidden' value='"+colors[color]+"' name='tiles_hex_["+product_ids['tiles'][color]+"]' data_attr_id='"+product_ids['tiles'][color]+"'>");
          jQuery("#custom-product-form").append("<input type='hidden' value='"+tiles[color]+"' name='tiles_qty_["+product_ids['tiles'][color]+"]' data_attr_id='"+product_ids['tiles'][color]+"'>");
          jQuery("#custom-product-form").append("<input type='hidden' value='"+color+"' name='tiles_name_["+product_ids['tiles'][color]+"]' data_attr_id='"+product_ids['tiles'][color]+"'>");
          var line_container = jQuery("<div>").addClass("sid-report-tiles-line-color");
          var code = colors[color];
          var color_img_light = jQuery("<img>").addClass("color-img").attr("src", siteURL + "custom-pattern.png");
          if(code.startsWith("#")){
            color_img_light.css("background-color", code);
          }else{
            color_img_light.css("background-image", "url(" + code + ")");
          }
          var color_container = jQuery("<div>").addClass("color-cont");
          color_container.append(color_img_light);
          line_container.append(color_container);
          
          var tile_color_name = jQuery("<i>").html(color + ": ");
          var tile_color_value = tiles[color];
          num_tiles += tile_color_value;
          var tile_color_container = jQuery("<div>").addClass("report_color_container");
          tile_color_container.append(tile_color_name);
          tile_color_container.append(tile_color_value);
          line_container.append(tile_color_container);
          selected_items['cart'][product_ids['tiles'][color]] = tile_color_value;
          tile_text.append(line_container);
        }
      }
    }
  }
  var tile_color_container = jQuery("<div>").addClass("report_color_container");
  var tile_color_name = jQuery("<span>").html("Total: ");
  var tile_color_value = num_tiles;
  tile_color_container.append(tile_color_name);
  tile_color_container.append(tile_color_value);
  var spr_size = Math.pow( jQuery("#tile-primary input[type='radio']:checked").data('size') / 12, 2);

  selected_items['sid-room-area'] = format_measure(real_area) + ((unit_system=="metric")?"&sup2;":"&nbsp;ft&sup2;");

  report.append(report_container("Room Area", selected_items['sid-room-area']));
  selected_items['sid-tile-square-footage'] = format_measure_imperial(num_tiles * spr_size.toFixed(2)) + "&nbsp;ft&sup2;";

  report.append(report_container("Tile Square Footage", selected_items['sid-tile-square-footage']));
  
  selected_items['sid-total-tiles'] = num_tiles;

  report.append(report_container_multiple(["Total Tiles","Number of Tiles"],[num_tiles,tile_text]));
  jQuery("#quantity-tile").val(num_tiles);
  var edges = report_edges_and_corners(edges_and_corners.edges, "edges");
  report.append(report_container("Total Edges", edges));
  var corners = report_edges_and_corners(edges_and_corners.corners, "corners");
  report.append(report_container("Total Corners", corners));
  console.log("Test saaddddd");
  console.log(jQuery("#toggle_installation").val());
  if(jQuery("#toggle_installation").val() == 'Yes') {
    report.append('<div class="sid-report-section"><div class="sid-report-label">Would you like us to install the tiles for you?</div><div class="sid-report-value"><label style="width:100%"><input type="radio" name="installation" value="yes"> Yes</label><label style="width:100%"><input type="radio" name="installation" value="no"> No</label></div><div class="email-display"><p>Email us at: <a href="mailto:sales@ittape.com">sales@ittape.com</a></p><br> <label style="width:100%">Name</label><input type="text" name="sid_Name" id="sid_Name" placeholder="Name" style=" width: 100%;    margin: 5px 0;    font-size: 20px;    padding: 10px 5px; "><br> <label style="width:100%">Email</label><input type="text" name="sid_Email" id="sid_Email" placeholder="Email" style=" width: 100%;    margin: 5px 0;    font-size: 20px;    padding: 10px 5px; "  ><br> <label style="width:100%">Phone</label><input type="text" name="sid_Phone" id="sid_Phone" placeholder="Phone" style=" width: 100%;    margin: 5px 0;    font-size: 20px;    padding: 10px 5px; "><br> <label style="width:100%">Postal</label><input type="text" name="sid_Postal" id="sid_Postal" placeholder="Postal Code" style=" width: 100%;    margin: 5px 0;    font-size: 20px;    padding: 10px 5px; "><br> <label style="width:100%">Address</label> <textarea placeholder="address" id="address" style=" width: 100%;    margin: 5px 0;    font-size: 20px;    padding: 10px 5px; "></textarea></div></div>');
  }
  if(jQuery("#show_hire").val() == 'Yes') {
    report.append('<div class="sid-report-section"><div class="sid-report-label">Hire a tile cutter €'+formatNumber(jQuery("#show_hire_price").val())+'/Per Day</div><div class="sid-report-value"><img src="'+jQuery("#hire_image").val()+'" style="width:150px;"><label for="days_rent" style="width:40px;font-size: 22px;padding: 5px;text-align: center;">Days</label><br><input type="text" placeholder="0" value="0" id="days_rent" style="width:40px;"></div></div>');
  }
}
function formatNumber(number) {
    var numStr = number.toString();
    if (numStr.length <= 2) {
        // This handles cases like '5' or '30' to become '0.05' or '0.30'
        return '0.' + numStr.padStart(2, '0');
    } else {
        // Insert a decimal two places from the end
        return numStr.slice(0, -2) + '.' + numStr.slice(-2);
    }
}

function report_container_multiple(labels, values, classes){
    var container = jQuery("<div>");
  container.before("<hr>");
  container.addClass("sid-report-section");
  if(classes != undefined){
    container.addClass(classes);
  }
  for (index in labels){
      container.append(jQuery("<div>").addClass("sid-report-label").html(labels[index]));
      container.append(jQuery("<div>").css("margin-bottom","5px").addClass("sid-report-value").html(values[index]));
  }
  return container;
}
function report_container(text, value, classes){
  var container = jQuery("<div>");
  container.before("<hr>");
  container.addClass("sid-report-section");
  if(classes != undefined){
    container.addClass(classes);
  }
  var fdLabel = jQuery("<div>").addClass("sid-report-label").html(text);
  container.append(fdLabel);
  var fdValue = jQuery("<div>").addClass("sid-report-value").html(value);

  container.append(fdValue);
  return container;
}

function report_edges_and_corners(elements, type){
  var unset_code = data.tiles.colors[unset_color];
  var product_ids = data.tiles.ids;
  var elements_types = {};
  
  for(var element_position in elements){
      if(elements.hasOwnProperty(element_position)){
        var element = elements[element_position];
        if(element.color != unset_code){
          if(elements_types[element.color] == undefined){
            elements_types[element.color] = 0;
          }
          elements_types[element.color]++;
        }
      }
  }
  
  var container = jQuery("<div>").addClass("sid-edges-tiles");
  var colors_inverted = {};
  var colors_data = data.tiles.colors;
  
  for(var key in colors_data[type]){
    colors_inverted[colors_data[type][key]] = key;
  }

  var total_edges = {};
  for(var color in elements_types){
    var count = elements_types[color];
    jQuery("#custom-product-form").append("<input type='hidden' value='" + color + "' name='" + type + "_hex_[" + product_ids[type][colors_inverted[color]] + "]' data_attr_id='" + product_ids[type][colors_inverted[color]] + "'>");
    jQuery("#custom-product-form").append("<input type='hidden' value='" + count + "' name='" + type + "_qty_[" + product_ids[type][colors_inverted[color]] + "]' data_attr_id='" + product_ids[type][colors_inverted[color]] + "'>");
    jQuery("#custom-product-form").append("<input type='hidden' value='" + colors_inverted[color] + "' name='" + type + "_name_[" + product_ids[type][colors_inverted[color]] + "]' data_attr_id='" + product_ids[type][colors_inverted[color]] + "'>");
    var element_container = jQuery("<div>")
      .addClass("sid-edges-and-corners-container");
    var color_container = jQuery("<div>");
    var color_img_light = jQuery("<img>").addClass("color-img").attr("src", siteURL + "/graphictrax-pattern.png");
    if(color.startsWith("#")){
      color_img_light.css("background-color", color);
    }else{
      color_img_light.css("background-image", "url('" + color + "')");
    }
    selected_items[type]['color'][color] = colors_inverted[color];
    selected_items[type]['count'][color] = count;
    var color_container = jQuery("<div>").addClass("color-cont");
    color_container.append(color_img_light);
    element_container.append(color_container);
    var tile_color_name = jQuery("<i>").html(colors_inverted[color] + ": ");
    var tile_color_container = jQuery("<div>").addClass("report_color_container");
    tile_color_container.append(tile_color_name);
    tile_color_container.append(count);
    selected_items['cart'][product_ids[type][colors_inverted[color]]] = count;
    if (!total_edges[type]) {
      total_edges[type] = 0;
    }
    total_edges[type] += count;
    element_container.append(tile_color_container);
    container.append(element_container);
  }
    if(total_edges['corners']) {
        jQuery("#quantity-corner").val(total_edges['corners']);
    }
    if(total_edges['edges']) {
      jQuery("#quantity-edges").val(total_edges['edges']);
    }
  return container;
}

function draw_measures(){
  var lines_container = new createjs.Container();
  if(selected_type != undefined){
    var margin = data.margin;
    var scale_size = calc_scale();
    var points = selected_type.real_points;
    var measures = selected_type.measures;
    
    for(var measures_position in measures){
      var measure = measures[measures_position];
      

      for(var line_position in measure){
          
          if (measure.hasOwnProperty(line_position)) {
        var line = measure[line_position];
        var axis = line.axis;
        var side = line.side;
        // var index = line.index;
        var readonly = line.readonly;
        
        var start = points[line.start][axis];
        var finish = points[line.finish][axis];
        var lenght = parseFloat(Math.abs(finish-start));
        var line = new createjs.Shape();
        var graphics = line.graphics;
        graphics.beginStroke(data.colors.measure);
        var text = new createjs.Text(format_measure(lenght/scale_size) + " (Area " + side + ")", data.text.measures.font, data.text.measures.color);
        text.textBaseline = "alphabetic";
        switch(parseInt(measures_position)){
          case(0):{
            graphics.moveTo(start+margin, margin*.8);
            graphics.lineTo(start+margin, margin*.5);
            graphics.lineTo(start+lenght+margin, margin*.5);
            graphics.lineTo(start+lenght+margin, margin*.8);
            text.x = start+margin;
            text.y = margin*.4;
            break;
          }
          case(1):{
            graphics.moveTo(stage.canvas.width-(margin*.8), start+margin);
            graphics.lineTo(stage.canvas.width-(margin*.5), start+margin);
            graphics.lineTo(stage.canvas.width-(margin*.5), start+lenght+margin);
            graphics.lineTo(stage.canvas.width-(margin*.8), start+lenght+margin);
            text.x = stage.canvas.width-(margin*.4);
            text.y = start+margin;
            text.rotation = 90;
            break;
          }
          case(2):{
            graphics.moveTo(finish+margin, stage.canvas.height-(margin*.8));
            graphics.lineTo(finish+margin, stage.canvas.height-(margin*.5));
            graphics.lineTo(finish+lenght+margin, stage.canvas.height-(margin*.5));
            graphics.lineTo(finish+lenght+margin, stage.canvas.height-(margin*.8));
            text.x = finish+margin;
            text.y = stage.canvas.height-(margin*.4)+12;
            break;
          }
          case(3):{
            graphics.moveTo(margin*.8, finish+margin);
            graphics.lineTo(margin*.5, finish+margin);
            graphics.lineTo(margin*.5, finish+lenght+margin);
            graphics.lineTo(margin*.8, finish+lenght+margin);
            text.x = margin*.4;
            text.y = finish+lenght+margin;
            text.rotation = -90;
            break;
          }
        }

        switch(unit_system){
          case("metric"):{
            jQuery("#area_" + side )
              .attr('readonly',readonly)
              .val(format_measure(lenght/scale_size).replace("m",""))
              .attr("axis",axis)
              .attr("length",measures[measures_position].length)
              .attr("start",start)
              .attr("finish",finish);
            break;
          }
          case("imperial"):
          default:{
            jQuery("#area_" + side )
              .attr('readonly',readonly)
              .val(format_measure(lenght/scale_size))
              .attr("axis",axis)
              .attr("length",measures[measures_position].length)
              .attr("start",start)
              .attr("finish",finish);
            break;
          }
        }
        lines_container.addChild(text);
        lines_container.addChild(line);
      }
      }
    }
    
    var area_points = [];
    for(var point_position in points){
      var point = points[point_position];
      var new_point = {
        x: point.x/scale_size
        , y: point.y/scale_size
      }
      area_points.push(new_point);
    }
    var room_size_area = calc_area(area_points);
    if(unit_system == "metric"){
      room_size_area*=data.convertion_factor;
    }

    room_size.html(format_measure(room_size_area) + "&sup2;");
    
    var center = calc_center(points);
    jQuery(".workspace_measure").removeAttr("style");
    switch(unit_system){
      case("metric"):{
        width.val(format_measure(center.width/scale_size).replace("m",""));
        height.val(format_measure(center.height/scale_size).replace("m",""));
        break;
      }
      case("imperial"):
      default:{
        width.val(format_measure(center.width/scale_size));
        height.val(format_measure(center.height/scale_size));
        break;
      }
    }
    
  }
  return lines_container;
}

function drawArrow(graphics, x, y, length, position, reverse = false) {
    var angle = (position % 2 === 0) ? 0 : 90; // 0 degrees for horizontal, 90 for vertical
    var dir = reverse ? 1 : -1; // Direction of the arrow

    if (position % 2 === 0) { // Horizontal
        graphics.moveTo(x, y);
        graphics.lineTo(x + dir * length, y + length);
        graphics.moveTo(x, y);
        graphics.lineTo(x + dir * length, y - length);
    } else { // Vertical
        graphics.moveTo(x, y);
        graphics.lineTo(x + length, y + dir * length);
        graphics.moveTo(x, y);
        graphics.lineTo(x - length, y + dir * length);
    }
}
function draw_with_drag_layer(){
  clear_stage();
  canvas_container.removeAllChildren();
  draw_layer_cero();
  canvas_container.addChild(draw_layer_drag());
  stage.addChild(canvas_container);
  stage.update();
}

function draw_all_types(){
  var margin = data.margin;
  var types = data.types;
  var factor = data.factor;
  var scale_size_units = stage.canvas.width/((Object.keys(data.types).length+1)*4);
  var scale_real_points = calc_scale()*data.inflate_factor;
  var group = new createjs.Container();
  
  var types_length = Object.keys(types).length;
  var type_space_width = (stage.canvas.width/(types_length+1));
  var type_separation_width = (type_space_width/(types_length+1));
  var current_type_space_width = 0;
  
  for(var position in types){
    var type = types[position];
    
    current_type_space_width += type_separation_width;
    var type_start_point_x = current_type_space_width; 
    var type_start_point_y = type.start_point.y;
    current_type_space_width += type_space_width;
    
    var points = type.points;

    var polygon = new createjs.Shape();
    var graphics = polygon.graphics;
    graphics.beginFill(data.colors.general_fill);
    graphics.beginStroke(data.colors.tile_stroke);
    graphics.moveTo(type_start_point_x + (points[0].x*scale_size_units), type_start_point_y + (points[0].y*scale_size_units));
    
    var real_points = [];
    var max_y = 0;
    for(var point_position in points){
      var point = points[point_position];
      real_points.push({
        x: (point.x*scale_real_points)
        , y: (point.y*scale_real_points)
      });
      var display_x = type_start_point_x + (point.x*scale_size_units);
      var display_y = type_start_point_y + (point.y*scale_size_units);
      if(display_y>max_y){
        max_y = display_y;
      }
      graphics.lineTo(display_x, display_y);
    }
    
    var center = calc_center(real_points); 
    var label = type.label;
    var text = new createjs.Text(label.text, data.text.all_types.font, data.text.all_types.color);
    text.x = type_start_point_x;
    text.y = max_y+margin;
    text.textBaseline = "alphabetic";
    
    type.real_points = real_points;
    polygon.type = type;
    
    polygon.addEventListener("mouseover", function(e) {
      var polygon = e.currentTarget;
      polygon.alpha *= .70;
      stage.update();
    });
    
    polygon.addEventListener("mouseout", function(e) {
      var polygon = e.currentTarget;
      polygon.alpha = 1;
      stage.update();
    });
    
    polygon.addEventListener("click", function(e) {
      var polygon = e.currentTarget;
      selected_type = polygon.type;
      init_dimentions();
      init_process_vars();
      
      load_step(2);
      jQuery("#unit_system_imperial").click();
      layers_reload(false);
    });
    
    group.addChild(text);
    group.addChild(polygon);
  }
  
  
  return group;
}

function draw_layer_cero(){
  if(current_stage > 1){
    drawing_container.removeAllChildren ();
    if(current_stage>=5){
      layer_matrix = draw_matriz();
      drawing_container.addChild(layer_matrix);
    }
    drawing_container.addChild(draw_drawing_area());
    drawing_container.addChild(draw_front_side_text());
    drawing_container.addChild(draw_measures());

    drawing_container.addChild(draw_selectd_type_real_points());
    
    if(current_stage>=4){
      draw_none_tile_areas();
      drawing_container.addChild(none_tile_poligons);
    }
    
    if(current_stage>=7){
      layer_borders_ands_edges = create_borders_and_edges();
      drawing_container.addChild(layer_borders_ands_edges);
    }

    drawing_container.addChild(drag_measures);
    stage.addChildAt(drawing_container, 0);
  }
}

function draw_drawing_area(){
  var margin = data.margin;
  var width = stage.canvas.width;
  var height = stage.canvas.height;
  var drawing_area = new createjs.Shape();
  var graphics = drawing_area.graphics;
  graphics.beginStroke(data.colors.drawing_area);
  graphics.moveTo(margin, margin);
  graphics.lineTo(width-margin, margin);
  graphics.lineTo(width-margin, height-margin);
  graphics.lineTo(margin, height-margin);
  graphics.lineTo(margin, margin);
  return drawing_area;
}

function draw_front_side_text(){
  var margin = data.margin;
  var width = stage.canvas.width;
  var height = stage.canvas.height;

  var drawing_text_container = new createjs.Container();
  var drawing_text_border = new createjs.Shape();
  var graphics_border = drawing_text_border.graphics;
  graphics_border.beginStroke(data.colors.drawing_area);
  graphics_border.moveTo(margin+4, height-margin-30);
  graphics_border.lineTo(margin+4, height-margin-4);
  graphics_border.lineTo(width-margin-4, height-margin-4);
  graphics_border.lineTo(width-margin-4, height-margin-30);

  var draw_text = new createjs.Text("Front Entrance", "bold 18px Arial ", "#2b3851");
  draw_text.x = (stage.canvas.width/2) - 70;
  draw_text.y = height-margin-8;
  
  draw_text.textBaseline = "alphabetic";
  drawing_text_container.addChild(drawing_text_border);
  drawing_text_container.addChild(draw_text);
  return drawing_text_container;
}
function draw_selectd_type_real_points(fill){
  var polygon = new createjs.Shape();
  if(selected_type != undefined){
    var margin = data.margin;
    var graphics = polygon.graphics;
    if(fill != undefined){
      graphics.beginFill(fill);
    }else{
      if(current_stage<5){
        graphics.beginFill(data.colors.general_fill);
      }
    }
    graphics.beginStroke(data.colors.tile_stroke);
    var first = null;

    var points = selected_type.real_points;
    for(var point_position in points){
      var point = points[point_position];
      graphics.lineTo(point.x+margin, point.y+margin);
      if(first == null){
        first = {
          x: point.x+margin
          , y: point.y+margin
        };
      }
    }
    graphics.lineTo(first.x, first.y);
  }
  return polygon;
}


function format_money(n){
  return "$" + n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

function format_measure(measure, small){
  var r;
  small = ((small == undefined)?false:small);
  switch(unit_system){
    case("metric"):{
      var measure_lenght = parseFloat(calc_meters("from", measure));
      r = measure_lenght.toFixed(3) + "m";
      if(small){
        r = (measure_lenght*100).toFixed(3) + "cm";
      }
      break;
    }
    case("centimeter"):{
      var measure_lenght = parseFloat(calc_meters("from", measure));
      r = (measure_lenght*100).toFixed(3) + "cm";
      break;
    }
    case("inches"):{
      var measure_lenght = parseFloat(calc_meters("from", measure));
      r = (measure_lenght*39.3701).toFixed(3) + "inches";
      break;
    }
    case("imperial"):
    default:{
      var measure_lenght = parseFloat(measure);
      var measure_lenght_units = calc_feet(measure_lenght);
      var measure_lenght_decimals = calc_inches(measure_lenght);
      if(measure_lenght_decimals == 12) {
        measure_lenght_units += 1;
        measure_lenght_decimals = 0;
      }
      r = measure_lenght_units + "'" + measure_lenght_decimals + "\"";
      if(small){
        r = ((measure_lenght_units*12)+measure_lenght_decimals) + "\"";
      }
      break;
    }
  }
  return r;
}


function format_measure_imperial(measure, small){
  var r;
  small = ((small == undefined)?false:small);
  
  var measure_lenght = parseFloat(measure);
  var measure_lenght_units = calc_feet(measure_lenght);
  var measure_lenght_decimals = calc_inches(measure_lenght);
  if(measure_lenght_decimals == 12) {
    measure_lenght_units += 1;
    measure_lenght_decimals = 0;
  }
  r = measure_lenght_units + "'" + measure_lenght_decimals + "\"";
  if(small){
    r = ((measure_lenght_units*12)+measure_lenght_decimals) + "\"";
  }
  
  return r;
}


function get_numeric_measures(measure, small){
  var measure = format_measure(measure, small);
  measure = measure.replace(" ", "");
  
  measure = measure.replace("cm", "");
  measure = measure.replace("\"", "");
  
  measure = measure.replace("m", "");
  measure = measure.replace("'", ".");
  
  return measure;
}

function calc_meters(type, measure){
  var factor = data.convertion_factor;
  var r = false;
  switch(type){
    case("from"):{
      r = measure*factor;
      break;
    }
    case("to"):{
      r = measure/factor;
      break;
    }
  }
  return r;
}

function calc_scale(){
  return calc_scale_number(scale.val());
}

function calc_scale_previous(){ 
  return calc_scale_number(scale.attr("data-previous"));
}

function calc_scale_number(scale_val){
  return data.scale/parseFloat(scale_val);
}

function calc_feet(lenght){
  return parseInt(lenght);
}

function calc_inches(lenght, use_feet){
  var feet = ((use_feet==undefined)?calc_feet(lenght):0);
  return parseInt((lenght-feet).toFixed(2)*12);
}

function calc_center(points){
  var min_x, min_y, max_x, max_y;
  if(points != undefined){
    for(var point_position in points){
      var point = points[point_position];
      var x = point.x;
      var y = point.y;
      if(min_x == undefined || x<min_x){
        min_x = x;
      }
      if(min_y == undefined || y<min_y){
        min_y = y;
      }
      if(max_x == undefined || x>max_x){
        max_x = x;
      }
      if(max_y == undefined || y>max_y){
        max_y = y;
      }
    }
  }
  var width = (max_x-min_x);
  var height = (max_y-min_y);
  return {
    min_x: min_x
    , min_y: min_y
    , max_x: max_x
    , max_y: max_y
    , width: width
    , height: height
    , x: (min_x+(width/2))
    , y: (min_y+(height/2))
  };
}

function calc_area(points) {
  var coordArray = [];
  for(var point_position in points){
      if (points.hasOwnProperty(point_position)) {
    var point = points[point_position];
    coordArray.push(point.x);
    coordArray.push(point.y);
      }
  }
  var x = coordArray,
    a = 0;
  if (x.length % 2) return -1;
  for (var i=0, iLen=x.length-2; i<iLen; i+=2) {
        if(!isNaN(x[i]) && !isNaN(x[i+3]) && !isNaN(x[i+2]) && !isNaN(x[i+1])) {
        a += x[i]*x[i+3] - x[i+2]*x[i+1];
        
      }
  }
  return Math.abs(a/2);
}

function imperial_format_to_decimal(measure){
  var imperial = measure.match(/(\d+')?(\d+")?/);
  var result = false;
  if(imperial != null){
    var feets = parseInt(imperial[1]);
    var inches = imperial[2] == undefined?0:parseInt(imperial[2]);
    result = feets + (inches/12);
  }
  return result;
}

function imperial_number_to_decimal(measure){
  var result = false;
  if(isNumber(measure)){
    result = parseInt(measure) + ((measure%1)/1.2);
  }
  return result;
}

function imperial_numbert_to_format_inches(measure){
  var result = "0cm";
  if(isNumber(measure)){
    result = parseInt(measure) + "'" + ((measure%1)/1.2) + "\"";
  }
  return result;
}

function imperial_numbert_to_format_centimeter(measure){
  var result = "0'0\"";
  if(isNumber(measure)){
    result = parseInt(measure) + "'" + ((measure%1)/1.2) + "\"";
  }
  return result;
}

function imperial_numbert_to_format(measure){
  var result = "0'0\"";
  if(isNumber(measure)){
    result = parseInt(measure) + "'" + ((measure%1)/1.2) + "\"";
  }
  return result;
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function calc_roundup(value){
  var entero = parseInt(value);
  return ((entero<value)?entero+1:entero);
}

function calc_tiles(){
  var total = {};
  if(current_stage>1){
    var none_tiles = [];
    var figures = selected_type.none_tiles_areas;
    for(var figure_position in figures){
      var figure = figures[figure_position];
      if(!(figure && figure.points && typeof figure.points[0] !== "undefined")){
        continue; 
      }
      var polygon = draw_none_tile_poligon(figure);
      polygon.figure = figure;
      none_tiles.push(polygon);
    }
    
    for(var row_position in matriz){
      var row = matriz[row_position];
      for(var tile_position in row){
        var tile = row[tile_position];
        if(tile.front.graphics.points_count>0){
          var hit_pass = 0;
          var points = tile.front.graphics.points;
          
          for(var none_tile_position in none_tiles){
              if (none_tiles.hasOwnProperty(none_tile_position)) {
            var none_tile = none_tiles[none_tile_position];
            for(var point_position in points){
                if (points.hasOwnProperty(point_position)) {
              var point = points[point_position];
              if(none_tile.hitTest(point.x, point.y)){
                hit_pass++;
              }
                }
            }
              }
          }
          if(hit_pass<Object.keys(points).length){
            var texture = tile.front.graphics.texture;
            var color = tile.back.graphics.color_name;
            if(total[texture] == undefined){
              total[texture] = {};
            }
            if(total[texture][color] == undefined){
              total[texture][color] = 0;
            }
            total[texture][color]++;
          }
        }
      }
    }
  }
  return total;
}

function calc_distance(x1, y1, x2,y2){
  var distance_x = x1-x2;
  var distance_y = y1-y2;
  return Math.pow(Math.pow(distance_x, 2)+Math.pow(distance_y, 2), .5);
}


function fill_edges_and_corners(keep_data){
    if(current_stage>1){
    if(edges_and_corners.edges == undefined){
      keep_data = false;
    }
    var real_points = selected_type.real_points;
    
    var real_points_lenght = 0;
    if(real_points['last']) {
        real_points_lenght = Object.keys(real_points).length-3;
    } else {
        real_points_lenght = Object.keys(real_points).length-1;
    }
    var edges = [];
    var corners = [];
    var ddData = jQuery("#tile-primary input[type='radio']:checked");
    var factor = parseFloat(ddData.data('size'))/12;
    var scale = calc_scale()*factor;
    var unset_code = data.tiles.colors[unset_color];
    var cont = 0;
    for(real_point_position in real_points){
        if (real_points.hasOwnProperty(real_point_position) && !isNaN(real_point_position)) {
            var real_point = real_points[real_point_position];
      var real_point_pair = get_pair_point_edges_and_corners(real_points_lenght, real_point_position, real_points);
      var horizontal = (real_point_pair && real_point.x == real_point_pair.x && real_point.y != real_point_pair.y);
      var vertical = (real_point_pair && real_point.y == real_point_pair.y && real_point.x != real_point_pair.x);
      
      
      if(horizontal || vertical){

        var points = [
          jQuery.extend({}, real_point)
          , jQuery.extend({}, real_point_pair)
        ];
        var center = calc_center(points);
            
        var low_limit_c = parseInt(((horizontal)?center.min_y:center.min_x)/scale);
        var high_limit_c = calc_roundup(((horizontal)?center.max_y:center.max_x)/scale);
        var limit_c = high_limit_c - low_limit_c;
        for(var c = 0; c < limit_c; c++){
          
          var a = {x: 0, y: 0};
          var b = {x: 0, y: 0};
          var direction = "";
          if(horizontal){
              if((center.max_y - (c*scale)) < center.min_y){
              continue;
            }
            b.y = center.max_y - (c*scale);
            a.y = center.max_y - (c*scale) - scale;
            if(a.y < center.min_y){
              a.y = center.min_y;
            }
          
            a.x = center.min_x;
            b.x = center.min_x;
            direction = "horizontal";

          }else{
            a.x = center.min_x + (c*scale);
              
            if(a.x/scale == 0){
              b.x = a.x + scale;
            }else{
              var intvalue = parseFloat(a.x/scale)
              if(c != 0){
                  a.x = (parseFloat(a.x/scale))*scale;
              }
              b.x = (parseFloat(a.x/scale)+1)*scale;
            }
            a.y = center.min_y;
            b.y = center.min_y;
            direction = "vertical";
            if(b.x > center.max_x || c == limit_c-1){
              b.x = center.max_x
            }
          }
          var color = ((keep_data && edges_and_corners.edges[cont] != undefined)?edges_and_corners.edges[cont].color:unset_code);
          edges.push(
            {
              points: {0: a, 1: b},
              pieces: 1,
              direction: direction,
              type: undefined,
              outer: selected_type.points[real_point_position].outer ? true : false,
              color: color,
              section: real_point_position
            }
          );
          cont++;
        }
      }
      corners.push(
        {
          point: real_point_pair
          , color: ((keep_data && edges_and_corners.corners[real_point_position] != undefined)?edges_and_corners.corners[real_point_position].color:unset_code)
        }
      );
        }
    }
        
    edges_and_corners = {
      edges: edges
      , corners: corners
    };
  }
}

function get_pair_point_edges_and_corners(real_points_lenght, real_point_position, real_points){
  real_point_pair = real_points[0];
  if(real_point_position != real_points_lenght){
    real_point_pair = real_points[parseInt(real_point_position)+1]; 
  }
  return real_point_pair;
}

function create_borders_and_edges(){
  var unset_code = data.tiles.colors[unset_color];
  var margin = data.margin;
  var container = new createjs.Container();
  var scale = calc_scale();
  container.x = margin;
  container.y = margin;

  var edges = edges_and_corners.edges;
  var corners = edges_and_corners.corners;
  for(var edge_position in edges){
    var edge = edges[edge_position];
    var points = edge.points;
    if(current_stage==7 || edge.color != unset_code){
      var rectangle = new createjs.Shape();
      var center = calc_center(points);
      var pieces = 0;
      switch(edge.direction){
        case("horizontal"):{
          pieces = center.height;
          center.width += ((center.min_x == 0 || edge.outer)?-6:6);
          break;
        }
        case("vertical"):{
          pieces = center.width;
           
          center.height += ((center.min_y == 0 || edge.outer)?-6:6);
          break;
        }
      }
      rectangle.alpha = 1;
      rectangle.graphics.beginFill(edge.color).drawRect(center.min_x, center.min_y, center.width, center.height);

      rectangle.metadata = {
        index: edge_position
        , pieces : pieces
      };
      
      rectangle.on("mousedown", function(evt) {
        edge_change(evt);
      });
      
      rectangle.on("mouseover", function(evt) {
        if(stage_click){
          edge_change(evt);
        }
      });     
      container.addChild(rectangle);
    }
  }
  for(var corner_position in corners){
      if (corners.hasOwnProperty(corner_position)) {
    if(corner_position%2 == 0){

      
      var previuos_value = parseInt(corner_position)-1;
      var corner_pair = corners[(previuos_value>0?(previuos_value):(corners.length-1))];
      var corner_prev = corners[(previuos_value>0?(previuos_value-1):(corners.length-2))];
      var corner = corners[corner_position];
      var corner_next = corners[parseInt(corner_position)+1];
      if(
        ((
          corner_pair && corner_pair.point && corner && corner.point && corner_pair.point.x == corner.point.x 
          && corner_pair.point.y == corner.point.y
        )
        && !(
          (
            corner_prev.point.y == 0 
            && corner_prev.point.x != 0 
            && corner.point.x < corner_next.point.x
            && corner.point.y > corner_prev.point.y 
          )
          ||
          (
            corner.point.y == corner_prev.point.y
            && corner.point.x == corner_next.point.x 
            && corner.point.x < corner_prev.point.x
            && corner.point.y < corner_next.point.y 
          )
        ))
        || (
            
            corner_prev && corner_prev.point
            && corner_next && corner_next.point
          && corner.point.x < corner_prev.point.x
          && corner.point.y < corner_next.point.y
          && corner.point.y == corner_prev.point.y
          && corner.point.x == corner_next.point.x
        ) 
      ){

        var angle = selected_type.points[corner_position].angle;
    
        var rectangle = new createjs.Shape();
        rectangle.graphics.setStrokeStyle(8);
        rectangle.graphics.beginStroke(corner.color);
        rectangle.graphics.beginFill(corner.color);
        rectangle.graphics.arc(corner.point.x,corner.point.y, data.tiles.conf.corners_diameter, Math.PI*(0.5*angle), Math.PI*(0.5*(angle+1)));
        rectangle.metadata = {
          index: corner_position
        };
        rectangle.on("mousedown", function(evt) {
          corner_change(evt);
        });
        container.addChild(rectangle);
      }
    }
      }
  }
  return container;
}

function edge_change(evt){
  if(current_stage==7){
    var rectangle = evt.target;
    var metadata = rectangle.metadata;
    var edge = edges_and_corners.edges[metadata.index];
    edge.type = 15.75;
    edge.color = jQuery('#edges-color input[type="radio"]:checked').data('color');
    var size = data.tiles.edges[edge.type].size;
    edge.pieces = calc_roundup(((metadata.pieces/scale)*12)/size);
    edges_and_corners.edges[metadata.index] = edge;
    layer_borders_ands_edges = create_borders_and_edges();
    drawing_container.addChild(layer_borders_ands_edges);
    stage.update();
  }
}

function corner_change(evt){
    if(current_stage==7){
    var rectangle = evt.target;
    var metadata = rectangle.metadata;
    var corner = edges_and_corners.corners[metadata.index];
    corner.color = jQuery('#corners-color input[type="radio"]:checked').data('color');
    edges_and_corners.corners[metadata.index] = corner;
    layer_borders_ands_edges = create_borders_and_edges();
    drawing_container.addChild(layer_borders_ands_edges);
    stage.update();
  }
}


function update_code_base_template(matriz_width_count, matriz_height_count, x, y, template_val, color_1_code, color_2_code, color_3_code, color_4_code) {
  if(template_val == 1) {
    if(matriz_width_count > 3 ) {
      center_r = Math.floor(matriz_width_count / 2);
      center_y = Math.floor(matriz_height_count / 2);
      if(center_r == x) {
        if(y != matriz_height_count && y != 1 && y != 2 && y != center_y) {
          return color_2_code;
        }
      }
    }
    return color_1_code;
  } else if(template_val == 2) {
    if (x % 2 == 0) {
      if (y % 2 == 0) {
        var temp_y = matriz_height_count - y
        if (x >= temp_y) {
          return color_3_code;
        }
        return color_1_code;
      } else {
        return color_2_code;
      }
    } else {
      if (y % 2 == 0) {
        return color_2_code;
      } else {
        var temp_y = matriz_height_count - y
        if (x >= temp_y) {
          return color_3_code;
        }
        return color_1_code;
      }
    }
    return color_1_code;
  } else if(template_val == 3) {
    if (x % 2 == 0) {  // Check if x is even
      if (y % 2 == 0) {
        return color_1_code;  // For even y, return first color
      } else {
        return color_2_code;  // For odd y, return second color
      }
    } else {  // x is odd
      if (y % 2 == 0) {
        return color_2_code;  // For even y, return second color (opposite of even x)
      } else {
        return color_1_code;  // For odd y, return first color (opposite of even x)
      }
    }
    return color_1_code;
  } else if(template_val == 4) {
    var middle_row = Math.floor(matriz_width_count / 2);
    var new_x = x;
    var new_y = y;
    while (new_x >= 3) {
      new_x -= 3;
    }
    while (new_y >= 4) {
      new_y -= 3;
    }

    if(x >= middle_row) {
      if(new_x == 2) {
        if(new_y == 3) {
          return color_2_code;
        } else {
          return color_1_code;
        }
      } else if(new_x == 1) {
        if(new_y == 2) {
          return color_2_code;
        } else {
          return color_1_code;
        }
      } else {
        if(new_y == 1) {
          return color_2_code;
        } else {
          return color_1_code;
        }
      }

    } else {
      if(new_x == 2) {
        if(new_y == 1) {
          return color_2_code;
        } else {
          return color_1_code;
        }
      } else if(new_x == 1) {
        if(new_y == 2) {
          return color_2_code;
        } else {
          return color_1_code;
        }
      } else {
        if(new_y == 3) {
          return color_2_code;
        } else {
          return color_1_code;
        }
      }
    }
    return color_1_code;
  } else if(template_val == 5) {
    if(matriz_width_count > 5 ) {
      center_r = Math.floor(matriz_width_count / 2);
      prev_r = Math.floor(matriz_width_count / 2) - 1;
      next_r = Math.floor(matriz_width_count / 2) + 1;
      if(prev_r == x) {
        return color_2_code;
      }
      if(center_r == x) {
        return color_3_code;
      }
      if(next_r == x) {
        return color_4_code;
      }
    }
    return color_1_code;
  } else {
    return color_1_code;
  }
}
function update_color_base_template(matriz_width_count, matriz_height_count, x, y, template_val, color_1_color, color_2_color, color_3_color, color_4_color) {
  
  if(template_val == 1) {
    center_r = Math.floor(matriz_width_count / 2);
    if(center_r == x) {
      if(y != matriz_height_count && y != 1 && y != 2) {
        return color_2_color;
      }
    }
    return color_1_color;
  } else if(template_val == 2) {
    if (x % 2 == 0) {
      if (y % 2 == 0) {
        if (x < y) {
          return color_3_color;
        }
        return color_1_color;
      } else {
        return color_2_color;
      }
    } else {
      if (y % 2 == 0) {
        return color_2_color;
      } else {
        if (x < y) {
          return color_3_color;
        }
        return color_1_color;
      }
    }
    return color_1_color;
  } else if(template_val == 3) {
    if (x % 2 == 0) {  // Check if x is even
      if (y % 2 == 0) {
        return color_1_color;  // For even y, return first color
      } else {
        return color_2_color;  // For odd y, return second color
      }
    } else {  // x is odd
      if (y % 2 == 0) {
        return color_2_color;  // For even y, return second color (opposite of even x)
      } else {
        return color_1_color;  // For odd y, return first color (opposite of even x)
      }
    }
    return color_1_color;
  } else if(template_val == 4) {
    var middle_row = Math.floor(matriz_width_count / 2);
    var new_x = x;
    var new_y = y;
    while (new_x >= 3) {
      new_x -= 3;
    }
    while (new_y >= 4) {
      new_y -= 3;
    }

    if(x >= middle_row) {
      if(new_x == 2) {
        if(new_y == 3) {
          return color_2_color;
        } else {
          return color_1_color;
        }
      } else if(new_x == 1) {
        if(new_y == 2) {
          return color_2_color;
        } else {
          return color_1_color;
        }
      } else {
        if(new_y == 1) {
          return color_2_color;
        } else {
          return color_1_color;
        }
      }

    } else {
      if(new_x == 2) {
        if(new_y == 1) {
          return color_2_color;
        } else {
          return color_1_color;
        }
      } else if(new_x == 1) {
        if(new_y == 2) {
          return color_2_color;
        } else {
          return color_1_color;
        }
      } else {
        if(new_y == 3) {
          return color_2_color;
        } else {
          return color_1_color;
        }
      }
    }
    return color_1_color;
    
  } else if(template_val == 5) {
    if(matriz_width_count > 5 ) {
      center_r = Math.floor(matriz_width_count / 2);
      prev_r = Math.floor(matriz_width_count / 2) - 1;
      next_r = Math.floor(matriz_width_count / 2) + 1;
      if(prev_r == x) {
        return color_2_color;
      }
      if(center_r == x) {
        return color_3_color;
      }
      if(next_r == x) {
        return color_4_color;
      }
    }
    return color_1_color;
  } else {
    return color_1_color;
  }
}

function update_matrix_base_template(tile_texture, matriz_width_count, matriz_height_count, x, y, template_val, color_1_code, color_2_code, color_3_code, color_4_code, color_1_color, color_2_color, color_3_color, color_4_color){
  var code = color_1_code;
  var color = color_1_color;
  if(template_val == 1) {
    center_r = Math.floor(matriz_width_count / 2);
    if(center_r == x) {
      if(y != matriz_height_count && y != 1 && y != 2) {
        code = color_2_code;
        color = color_2_color;
      }
    }
  } else if(template_val == 2) {
    if (x % 2 == 0) {
      if (y % 2 == 0) {
        if (x < y) {
          code = color_3_code;
          color = color_3_color;
        }
        code = color_1_code;
        color = color_1_color;
      } else {
        code = color_2_code;
        color = color_2_color;
      }
    } else {
      if (y % 2 == 0) {
        code = color_2_code;
        color = color_2_color;
      } else {
        if (x < y) {
          code = color_3_code;
          color = color_3_color;
        }
        code = color_1_code;
        color = color_1_color;
      }
    }
  } else if(template_val == 3) {
    if (x % 2 == 0) {  // Check if x is even
      if (y % 2 == 0) {
        code = color_1_code;
        color = color_1_color;
      } else {
        code = color_2_code;
        color = color_2_color;
      }
    } else {
      if (y % 2 == 0) {
        code = color_2_code;
        color = color_2_color;
      } else {
        code = color_1_code;
        color = color_1_color;
      }
    }
  } else if(template_val == 4) {

    var middle_row = Math.floor(matriz_width_count / 2);
    var new_x = x;
    var new_y = y;
    while (new_x >= 3) {
      new_x -= 3;
    }
    while (new_y >= 4) {
      new_y -= 3;
    }

    if(x >= middle_row) {
      if(new_x == 2) {
        if(new_y == 3) {
          code = color_2_code;
          color = color_2_color;
        } else {
          code = color_1_code;
          color = color_1_color;
        }
      } else if(new_x == 1) {
        if(new_y == 2) {
          code = color_2_code;
          color = color_2_color;
        } else {
          code = color_1_code;
          color = color_1_color;
        }
      } else {
        if(new_y == 1) {
          code = color_2_code;
          color = color_2_color;
        } else {
          code = color_1_code;
          color = color_1_color;
        }
      }

    } else {
      if(new_x == 2) {
        if(new_y == 1) {
          code = color_2_code;
          color = color_2_color;
        } else {
          code = color_1_code;
          color = color_1_color;
        }
      } else if(new_x == 1) {
        if(new_y == 2) {
          code = color_2_code;
          color = color_2_color;
        } else {
          code = color_1_code;
          color = color_1_color;
        }
      } else {
        if(new_y == 3) {
          code = color_2_code;
          color = color_2_color;
        } else {
          code = color_1_code;
          color = color_1_color;
        }
      }
    }
  } else if(template_val == 5) {
    code = color_1_code;
    color = color_1_color;
  }
  var new_matrix_data = {
    x:x,
    y:y,
    tile_texture: tile_texture,
    code: code,
    color: color
  };
  return new_matrix_data;
}
function create_matrix(keep_data){
  if(current_stage > 1){
    if(matriz_changed || matriz == undefined || matriz[0] == undefined){
      keep_data = false;
    }
    var polygon = draw_selectd_type_real_points("rgba(255,255,255,1)");
    var margin = data.margin;
    matriz_data_new = {}
    var matriz_new = {};
    var current_scale = calc_scale();
    var center = calc_center(selected_type.real_points);
    var matriz_width = (center.width)/current_scale;
    var matriz_height = (center.height)/current_scale;
    var tile_size = 15.75;
    
    var current_tile_scale = current_scale/12*tile_size;
    var matriz_width_count = calc_roundup(calc_inches(matriz_width, false)/tile_size);
    var matriz_height_count = calc_roundup(calc_inches(matriz_height, false)/tile_size);
    var matriz_height_value = parseFloat(calc_inches(matriz_height, false)/tile_size).toFixed(3);
    var tile_1 = jQuery("#tile-primary input[type='radio']:checked").val();
    var color_1 = jQuery("#color-primary input[type='radio']:checked");
    var color_1_code = color_1.data('color');
    var color_1_color = color_1.val();
    var color_2 = jQuery("#color-second input[type='radio']:checked");
    var color_2_code = color_2.data('color');
    var color_2_color = color_2.val();
    var color_3 = jQuery("#color-third input[type='radio']:checked");
    var color_3_code = color_3.data('color');
    var color_3_color = color_3.val();
    var color_4 = jQuery("#color-fourth input[type='radio']:checked");
    var color_4_code = color_4.data('color');
    var color_4_color = color_4.val();
    var template_val = $('.tileimage.selected_tile').attr("template");
    for(var x = 0; x < matriz_width_count; x++){
      matriz_data_new[x] = {};
      matriz_new[x] = {};
      var xv = x*current_tile_scale;
      var xs = [
        xv
        , xv+current_tile_scale
      ];
      for(var y = matriz_height_count; y > 0; y--){
        var tile_texture = 'CUSTOM-RIB04';
        var code = update_code_base_template(matriz_width_count, matriz_height_count, x, y, template_val, color_1_code, color_2_code, color_3_code, color_4_code);
        var color = update_color_base_template(matriz_width_count, matriz_height_count, x, y, template_val, color_1_color, color_2_color, color_3_color, color_4_color);

        if(keep_data && matriz[x] != undefined && matriz[x][y] != undefined){
          var tile_data = matriz[x][y];
          var front = tile_data.front.graphics;
        }
        var yv = center.height - ((matriz_height_count-y)*current_tile_scale);
        var ys = [
          (yv-current_tile_scale) < 0 ? 0 : yv-current_tile_scale ,
          yv-1
        ];

        if(matriz_changed){
          if(matriz_data[x] != undefined && matriz_data[x][y] != undefined){
            code = matriz_data[x][y].code;
            color = matriz_data[x][y].color;
          }
        }

        

        let index = x + "_" + y;

        if(custom_tile_data[index] && custom_tile_data[index].code && current_stage >= 6) {
          code = custom_tile_data[index].code;
          color = custom_tile_data[index].color;
                }

        var tile = draw_tile(xs, ys, tile_texture, code, color, polygon, margin, graphics, center, current_tile_scale);
        var graphics = tile.front.graphics;
        if(graphics.points_count>0){
          var new_matrix_data = update_matrix_base_template(tile_texture, matriz_width_count, matriz_height_count, x, y, template_val, color_1_code, color_2_code, color_3_code, color_4_code, color_1_color, color_2_color, color_3_color, color_4_color);

          if(typeof matriz_data !== "undefined" && typeof matriz_data[x] !== "undefined" && typeof matriz_data[x][y] !== "undefined") {
            new_matrix_data.code = matriz_data[x][y].code;
            new_matrix_data.color = matriz_data[x][y].color;
          }
          
          tile.front.matriz_data = new_matrix_data;
          tile.back.matriz_data = new_matrix_data;
          
          var tile_action = jQuery.extend({}, tile.back);
          tile_action.alpha = 0.01;
          tile_action.on("mouseover", function(evt) {
            if(stage_click){
              change_custom_tile(evt);
            }
          });
          tile_action.on("mousedown", function(evt) {
            container_visibility[index] = true;
            change_custom_tile(evt);
          });

          tile.action = tile_action;
          
          matriz_new[x][y] = tile;
          matriz_data_new[x][y] = new_matrix_data;
        
          if(code != color_1_code) {
            custom_tile_container[index] = matriz_new[x][y];
          }
        }
      }
    }
    matriz_changed = false;
    matriz_data = matriz_data_new;
    matriz = matriz_new;
  }
}

function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++ ) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}


function draw_tile(xs, ys, tile_texture, code, color, polygon, margin, graphics, center, current_tile_scale){
  var tile_back = new createjs.Shape();
  var graphics_back = tile_back.graphics;
  if(code.startsWith("#")){
    graphics_back.beginFill(code);
  }else{
    var m2d_b = new createjs.Matrix2D(current_tile_scale/100,0,0,current_tile_scale/100,xs[0], ys[0]);
    graphics_back.beginBitmapFill(color_images[code],'no-repeat', m2d_b);
  }

  graphics_back.color_name = color;
  graphics_back.color_code = code;
  graphics_back.current_tile_scale = current_tile_scale;
  graphics_back.points = [];
  graphics_back.points_count = 0;
  graphics_back.setStrokeStyle(1.5);
  graphics_back.beginStroke(data.colors.tile_stroke + "00");
  add_matriz_tile_point(polygon, xs[0], ys[0], margin, graphics_back, center);
  add_matriz_tile_point(polygon, xs[1], ys[0], margin, graphics_back, center);
  add_matriz_tile_point(polygon, xs[1], ys[1], margin, graphics_back, center);
  add_matriz_tile_point(polygon, xs[0], ys[1], margin, graphics_back, center);

  fix_points(polygon, margin, graphics_back, current_tile_scale);

  if(graphics_back.points_count){
    for(var pp in graphics_back.points){
      var p = graphics_back.points[pp];
      if(p.valid ){
        graphics_back.lineTo(p.x, p.y);
      }
    }
  }
  var p = graphics_back.points[0];
  if(p.valid){
    graphics_back.lineTo(p.x, p.y);
  }
  
  
  var tile = new createjs.Shape();
  var graphics = tile.graphics;
  var m2d = new createjs.Matrix2D(current_tile_scale/100,0,0,current_tile_scale/100,xs[0], ys[0]);
  graphics.beginBitmapFill(tile_images[tile_texture],'no-repeat', m2d);
  graphics.texture = tile_texture;
  graphics.current_tile_scale = current_tile_scale;
  graphics.points = [];
  graphics.setStrokeStyle(1.5);
  graphics.beginStroke(data.colors.tile_stroke);
  graphics.points_count = 0;
  add_matriz_tile_point(polygon, xs[0], ys[0], margin, graphics, center);
  add_matriz_tile_point(polygon, xs[1], ys[0], margin, graphics, center);
  add_matriz_tile_point(polygon, xs[1], ys[1], margin, graphics, center);
  add_matriz_tile_point(polygon, xs[0], ys[1], margin, graphics, center);
  fix_points(polygon, margin, graphics, current_tile_scale);
  if(graphics.points_count){
    for(var pp in graphics.points){
      var p = graphics.points[pp];
      if(p.valid){
        graphics.lineTo(p.x, p.y);
      }
    }
  }
  var p = graphics.points[0];
  if(p.valid){
    graphics.lineTo(p.x, p.y);
  }
  
  
  return {back: tile_back, front: tile, action: tile_action};
}


var eventCode = "";
var eventColor = "";
var eventTileTexture = "";
var eventTileTexture = "";
var eventCustomTile = false;

function change_custom_tile(evt){
  
  if(current_stage==6){
    let tile = matriz[evt.target.matriz_data.x][evt.target.matriz_data.y];
    let custom_matrix_data = tile.action.matriz_data;
    let color_custom;
    let tile_texture_custom;
    let color_primary;
    let tile_texture_primary;

    let custom_index = evt.target.matriz_data.x + "_" + evt.target.matriz_data.y;
    
    if(evt.type == 'mousedown'){
      color_primary = jQuery('#color-primary input[type="radio"]:checked');
      tile_texture_primary = jQuery('#tile-primary input[type="radio"]:checked').val();
      color_custom = jQuery('#color-custom input[type="radio"]:checked');
      tile_texture_custom = jQuery('#tile-custom input[type="radio"]:checked').val();
      
      if(custom_tile_data[custom_index] && custom_tile_data[custom_index].custom_tile){
        eventCode = color_primary.data('color');;
        eventColor = color_primary.val();
        eventTileTexture = tile_texture_primary;
        eventCustomTile = false;
      } else {
        eventCode = color_custom.data('color');;
        eventColor = color_custom.val();
        eventTileTexture = tile_texture_custom;
        eventCustomTile = true;
      }

    }

    custom_tile_data[custom_index] = {
      x:evt.target.matriz_data.x,
      y:evt.target.matriz_data.y,
      tile_texture: eventTileTexture,
      code: eventCode,
      color: eventColor,
      custom_tile: eventCustomTile
    };
    
    matriz_data[evt.target.matriz_data.x][evt.target.matriz_data.y] = {
      x:evt.target.matriz_data.x,
      y:evt.target.matriz_data.y,
      tile_texture: eventTileTexture,
      code: eventCode,
      color: eventColor
    };
          

    let tile_back_new = tile.back;
    let graphics_back_new = tile_back_new.graphics;
    
    if(eventCode.startsWith("#")){
      graphics_back_new.beginFill(eventCode);
    }else{
      var m2d_b = new createjs.Matrix2D(current_tile_scale/100,0,0,current_tile_scale/100,init_point.x, init_point.y);
      graphics_back_new.beginBitmapFill(color_images[eventCode],'no-repeat', m2d_b);
    }
    graphics_back_new.color_code = eventCode;
    graphics_back_new.color_name = eventColor;
    graphics_back_new.setStrokeStyle(1.5);
    graphics_back_new.beginStroke(data.colors.tile_stroke + "00");
    for(let pp in graphics_back_new.points){
      let p = graphics_back_new.points[pp];
      if(graphics_back_new.points_count){
        graphics_back_new.lineTo(p.x, p.y);
      }
    }

    layer_matrix.removeChild(matriz[custom_matrix_data.x][custom_matrix_data.y].back);
    layer_matrix.removeChild(matriz[custom_matrix_data.x][custom_matrix_data.y].front);
    layer_matrix.removeChild(matriz[custom_matrix_data.x][custom_matrix_data.y].action);

    matriz[custom_matrix_data.x][custom_matrix_data.y].back = tile_back_new;
    layer_matrix.addChild(matriz[custom_matrix_data.x][custom_matrix_data.y].back);
    layer_matrix.addChild(matriz[custom_matrix_data.x][custom_matrix_data.y].front);
    layer_matrix.addChild(matriz[custom_matrix_data.x][custom_matrix_data.y].action);

    stage.update();

  }
}

function draw_matriz(){
  var container = new createjs.Container();
  var margin = data.margin;
  container.x=margin;
  container.y=margin;
  for(var x in matriz){
    for(var y in matriz[x]){
      container.addChild(matriz[x][y].back);
      container.addChild(matriz[x][y].front);
      container.addChild(matriz[x][y].action);
    }
  }
  return container; 
}

function fix_points_polygon_borders(points, real_points, position, current_tile_scale){
  var distance_center = current_tile_scale/2;
  var center = calc_center(points);
  
  var inner_distance = calc_distance(center.x, center.y, center.x+distance_center,center.y+distance_center)
  for(var x = Object.keys(real_points).length-1; x >= 0; x--){
    var real_point = real_points[x];
    if(typeof real_point !== 'undefined'){
    var distance = calc_distance(center.x, center.y, real_point.x, real_point.y);
    if(distance<=inner_distance){
      points.splice(position,0,jQuery.extend({valid: true}, real_point));
    }
    }
  }
  return points;
}

function fix_points(polygon, margin, graphics, current_tile_scale){
  var points = graphics.points;
  var real_points = jQuery.extend({}, selected_type.real_points);
  
  if(graphics.points_count == 3){
    if(!points[0].valid){
      var new_points = [
        jQuery.extend({}, points[2])
        , jQuery.extend({}, points[3])
        , jQuery.extend({}, points[3])
        , jQuery.extend({}, points[1])
        , jQuery.extend({}, points[1])
      ];
      var base = new_points[3];
      while(polygon.hitTest(base.x+margin-1, base.y+margin)){
        base.x--;
      }
      var base = new_points[2];
      while(polygon.hitTest(base.x+margin, base.y+margin-1)){
        base.y--;
      }
      graphics.points = fix_points_polygon_borders(new_points, real_points, 3, current_tile_scale);

    }else if(!points[1].valid){
      var new_points = [
        jQuery.extend({}, points[0])
        , jQuery.extend({}, points[0])
        , jQuery.extend({}, points[2])
        , jQuery.extend({}, points[2])
        , jQuery.extend({}, points[3])
      ];
      var base = new_points[1];
      while(polygon.hitTest(base.x+margin+1, base.y+margin)){
        base.x++
      }
      var base = new_points[2];
      while(polygon.hitTest(base.x+margin, base.y+margin-1)){
        base.y--;
      }
      graphics.points = fix_points_polygon_borders(new_points, real_points, 2, current_tile_scale);
    }else if(!points[2].valid){
      var new_points = [
        jQuery.extend({}, points[0])
        , jQuery.extend({}, points[1])
        , jQuery.extend({}, points[1])
        , jQuery.extend({}, points[3])
        , jQuery.extend({}, points[3])
      ];
      var base = new_points[3];
      while(polygon.hitTest(base.x+margin+1, base.y+margin)){
        base.x++;
      }
      var base = new_points[2];
      while(polygon.hitTest(base.x+margin, base.y+margin+1)){
        base.y++;
      }
      graphics.points = fix_points_polygon_borders(new_points, real_points, 3, current_tile_scale);
    }else if(!points[3].valid){
      var new_points = [
        jQuery.extend({}, points[0])
        , jQuery.extend({}, points[1])
        , jQuery.extend({}, points[2])
        , jQuery.extend({}, points[2])
        , jQuery.extend({}, points[0])
      ];
      var base = new_points[3];
      while(polygon.hitTest(base.x+margin-1, base.y+margin)){
        base.x--;
      }
      var base = new_points[4];
      while(polygon.hitTest(base.x+margin, base.y+margin+1)){
        base.y++;
      }
      graphics.points = fix_points_polygon_borders(new_points, real_points, 4, current_tile_scale);
    }
  }else if(graphics.points_count == 2){
    if(points[0].valid && points[3].valid){
      var base = points[1];
      while(!polygon.hitTest(base.x+margin, base.y+margin) && base.x >= points[0].x){
        base.x--;
      }
      var base = points[2];
      while(!polygon.hitTest(base.x+margin, base.y+margin) && base.x >= points[3].x){
        base.x--;
      }
      points[1].valid = true;
      points[2].valid = true;
      graphics.points = fix_points_polygon_borders(points, real_points, 2, current_tile_scale);
    }else if(points[0].valid && points[1].valid){
      var base = points[2];
      while(!polygon.hitTest(base.x+margin, base.y+margin) && base.y >= points[1].y){
        base.y--;
      }
      var base = points[3];
      while(!polygon.hitTest(base.x+margin, base.y+margin) && base.y >= points[0].y){
        base.y--;
      }
      points[2].valid = true;
      points[3].valid = true;
      graphics.points = fix_points_polygon_borders(points, real_points, 3, current_tile_scale);
    }else if(points[2].valid && points[3].valid){
      var base = points[0];
      while(!polygon.hitTest(base.x+margin, base.y+margin) && base.y <= points[3].y){
        base.y++;
      }
      var base = points[1];
      while(!polygon.hitTest(base.x+margin, base.y+margin) && base.y <= points[2].y){
        base.y++;
      }
      points[0].valid = true;
      points[1].valid = true;
      graphics.points = fix_points_polygon_borders(points, real_points, 1, current_tile_scale);
    }else if(points[1].valid && points[2].valid){
      var base = points[0];
      while(!polygon.hitTest(base.x+margin, base.y+margin) && base.x <= points[1].x){
        base.x++;
      }
      var base = points[3];
      while(!polygon.hitTest(base.x+margin, base.y+margin) && base.x <= points[2].x){
        base.x++;
      }
      points[0].valid = true;
      points[3].valid = true;
      graphics.points = fix_points_polygon_borders(points, real_points, 4, current_tile_scale);
    }
  }else if(graphics.points_count == 1){
    if(points[0].valid){
      var new_points = [
        jQuery.extend({}, points[0])
        , jQuery.extend({}, points[0])
        , jQuery.extend({}, points[0])
      ];
      var base = new_points[1];
      while(polygon.hitTest(base.x+margin+1, base.y+margin)){
        base.x++;
      }
      var base = new_points[2];
      while(polygon.hitTest(base.x+margin, base.y+margin+1)){
        base.y++;
      }
      
      graphics.points = fix_points_polygon_borders(new_points, real_points, 2, current_tile_scale);
    }else if(points[1].valid){
      var new_points = [
        jQuery.extend({}, points[1])
        , jQuery.extend({}, points[1])
        , jQuery.extend({}, points[1])
      ];
      var base = new_points[0];
      while(polygon.hitTest(base.x+margin-1, base.y+margin)){
        base.x--;
      }
      var base = new_points[2];
      while(polygon.hitTest(base.x+margin, base.y+margin+1)){
        base.y++;
      }
      graphics.points = fix_points_polygon_borders(new_points, real_points, 3, current_tile_scale);
    }else if(points[2].valid){
      var new_points = [
        jQuery.extend({}, points[2])
        , jQuery.extend({}, points[2])
        , jQuery.extend({}, points[2])
      ];
      var base = new_points[0];
      while(polygon.hitTest(base.x+margin-1, base.y+margin)){
        base.x--;
      }
      var base = new_points[1];
      while(polygon.hitTest(base.x+margin, base.y+margin-1)){
        base.y--;
      }
      graphics.points = fix_points_polygon_borders(new_points, real_points, 3, current_tile_scale);
    }else if(points[3].valid){
      var new_points = [
        jQuery.extend({}, points[3])
        , jQuery.extend({}, points[3])
        , jQuery.extend({}, points[3])
      ];
      var base = new_points[0];
      while(polygon.hitTest(base.x+margin+1, base.y+margin)){
        base.x++;
      }
      var base = new_points[1];
      while(polygon.hitTest(base.x+margin, base.y+margin-1)){
        base.y--;
      }
      graphics.points = fix_points_polygon_borders(new_points, real_points, 1, current_tile_scale);
    }
  }
}

function add_matriz_tile_point(polygon, x, y, margin, graphics, center){
  var point = {
    x: x
    , y: y
    , valid: false
  }
  if(polygon.hitTest(x+margin, y+margin)){
    point.valid = true;
    graphics.points_count++;
  }
  graphics.points.push(point);
}


jQuery(document).ready(function() {
    console.log("tessst");
    $('body').on('change', 'input[name="installation"]', function() {
        console.log("tessst");
        if (jQuery(this).val() === 'yes') {
            jQuery('.email-display').show();
        } else {
            jQuery('.email-display').hide();
        }
    });
});